import classnames from "classnames";
import { supabase } from "../index";
import { toast } from "react-toastify";
import { payment_url, plan_type_prod, website_url } from "../bootapi";

import { json, useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Backdrop, CircularProgress } from "@mui/material";

import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import {
  PricingPlanCarouselSetting,
  RoundButton,
  RoundButtonDark,
  card_number,
  getcardnumberforapi,
  makeThreeAttempts,
  showMessagePayment,
  stripeAppearance,
  toastobj,
} from "../commonutilities";

import {
  createStripeSubscription,
  createSubscription,
  getallsubscriptiondetail,
  seventhplans,
  updateStripePayment,
  getcardDetails,
  updatePlan,
  activeSubscription,
  giftCouponCheck,
  couponCheckNew,
  getThreeDIncomplete,
  getPendingPayment,
  getAfterSuccessThreeD,
} from "../services/paymentService";
import {
  Row,
  Col,
  Container,
  Button,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import {
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Input,
  Label,
  Form,
} from "reactstrap";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import "swiper/css";
import { v4 as uuidv4 } from "uuid";
import { Elements, useElements, useStripe } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import InfoIcon from "@mui/icons-material/Info";

function checkPlanType(subscriptionPlans, plan) {
  for (const sub of subscriptionPlans) {
    if (sub.plan_type !== plan.plan_type) {
      return true;
    }
  }
  return false;
}

function getUniqueKey(subscriptionPlans, plan) {
  for (const key in subscriptionPlans) {
    if (subscriptionPlans.hasOwnProperty(key)) {
      if (
        subscriptionPlans[key].subscription_plan_id === plan.activated_plan_id
      ) {
        return key;
      }
    }
  }
}

function checkActiveSubscription(
  subscriptionPlans,
  inAppPlans,
  stripePlans,
  currentPlan,
  type = "inApp"
) {
  /* console.log("Subscription Plans", subscriptionPlans);
  console.log("inAppPlans", inAppPlans);
  console.log("stripePlans Plans", stripePlans);
  console.log("currentPlan ", currentPlan); */
  if (type === "inApp") {
    for (const plan of inAppPlans) {
      let uniqueOne = getUniqueKey(subscriptionPlans, plan);
      let uniqueTwo = currentPlan.unique_key;
      // console.log(uniqueOne, "---", uniqueTwo);
      const uniqueOneParts = uniqueOne?.split("_");
      const uniqueTwoParts = uniqueTwo?.split("_");
      if (
        uniqueOneParts[1] === uniqueTwoParts[1] ||
        uniqueTwo === "year_all" ||
        uniqueTwo === "month_all"
      ) {
        toast.info(
          "Oops! It seems like your subscription is tied to the App Store. To manage your plan, please use the App Store interface.",
          toastobj
        );
        return true;
      }
      if (
        (uniqueOneParts[0] === "year" &&
          uniqueTwoParts[0] === "year" &&
          uniqueOneParts[1] === uniqueTwoParts[1]) ||
        uniqueOne === "year_all" ||
        (uniqueOneParts[1] === "all" &&
          uniqueOne === "month_all" &&
          uniqueTwo !== "year_all")
      ) {
        toast.info("You're already enjoying this plan's benefits!", toastobj);
        return true;
      }
    }
  } else {
    for (const plan of stripePlans) {
      let uniqueOne = getUniqueKey(subscriptionPlans, plan);
      let uniqueTwo = currentPlan.unique_key;
      // console.log(uniqueOne, "---", uniqueTwo);
      const uniqueOneParts = uniqueOne?.split("_");
      const uniqueTwoParts = uniqueTwo?.split("_");
      if (
        uniqueOne === uniqueTwo ||
        (uniqueOneParts[0] === "year" &&
          uniqueTwoParts[0] === "month" &&
          uniqueOneParts[1] === uniqueTwoParts[1]) ||
        (uniqueOneParts[0] === "year" &&
          uniqueTwoParts[0] === "year" &&
          uniqueOneParts[1] === uniqueTwoParts[1]) ||
        uniqueOne === "year_all" ||
        (uniqueOneParts[1] === "all" &&
          uniqueOne === "month_all" &&
          uniqueTwo !== "year_all")
      ) {
        toast.info("You're already enjoying this plan's benefits!", toastobj);
        return true;
      }
    }
  }
  return false;
}
function formatNumber(number) {
  let numberString = Number(number).toFixed(2);
  numberString = numberString.replace(/(\.[0-9])0$/, "$1");
  return parseFloat(numberString);
}

const CheckoutForm = ({
  paymentMethod,
  clientSecret,
  toggleLoader,
  updateStateOfThreeD,
  toggleCancel,
}) => {
  /*This functional component is basically for cards which require 3d authentication while updating*/
  const stripe = useStripe();
  const elements = useElements();
  const [senderDetails, setSenderDetails] = useState("");
  const [loader, setloader] = useState(true);
  const history = useNavigate();

  useEffect(() => {
    if (clientSecret && stripe) {
      stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
        switch (paymentIntent.status) {
          case "succeeded":
            showMessagePayment("Payment succeeded!", "success");
            // setMessage("Payment succeeded!");
            toggleCancel();
            break;
          case "processing":
            showMessagePayment(
              "Please wait your payment is processing.",
              "success"
            );
            // setMessage("Your payment is processing.");
            break;
          case "requires_payment_method":
            showMessagePayment(
              "Your payment was not unsuccessful, please try again.",
              "error"
            );
            toggleCancel();
            // setMessage("Your payment was not successful, please try again.");
            break;
          case "requires_action" || "requires_source_action":
            break;

          default:
            showMessagePayment("Something went wrong.", "error");
            // setMessage("Something went wrong.");
            toggleCancel();
            break;
        }
      });
      stripe
        .confirmPayment({
          payment_method: paymentMethod,
          clientSecret,
          redirect: "if_required",
          confirmParams: {
            return_url: `${website_url}/create_subscription`,
            // return_url: `http://localhost:3000/create_subscription`,
          },
        })
        .then(function (result) {
          // console.log("result:", result.error.code);
          if (result.error) {
            // Handle errors
            if (result.error.code) {
              showMessagePayment(`${result.error.message}`, "error");
              toggleCancel();
            }
            // else if(result.error.c)
            // console.error(result.error.message);
          } else {
            // Handle success or next action
            if (
              result.paymentIntent.status === "requires_action" ||
              result.paymentIntent.status === "requires_source_action"
            ) {
              // Handle the next action (e.g., 3DS authentication)
              // console.log("success.......87");
              handleNextAction(result.paymentIntent.client_secret);
            } else {
              toggleLoader();
              // Payment succeeded
              // handlePaymentSuccess(result.paymentIntent);
            }
          }
        });
    }
  }, [clientSecret, stripe]);
  function handleNextAction(clientSecret) {
    stripe.handleCardAction(clientSecret).then(function (confirmResult) {
      // console.log("result:.......100", confirmResult);
      if (confirmResult.error) {
        // Handle errors during next action
        // console.error(confirmResult.error.message);
      } else {
        // console.log("success.......103");
        // Next action (e.g., 3DS authentication) successful, confirm the payment again
        confirmPaymentAfterNextAction(clientSecret);
      }
    });
  }
  function confirmPaymentAfterNextAction(clientSecret) {
    stripe
      .confirmCardPayment(clientSecret, {
        payment_method: paymentMethod,
      })
      .then(function (confirmResult) {
        // console.log("result:.......117", confirmResult);
        if (confirmResult.error) {
          // Handle errors after next action
          // console.error(confirmResult.error.message);
        } else {
          toggleLoader();
          // console.log("success.......215");
          // Handle success or additional actions if needed
          // handlePaymentSuccess(confirmResult.paymentIntent);
        }
      });
  }

  return <div></div>;
};

const CardPayment = (args) => {
  const location = useLocation();
  const [cvv, setCVV] = useState("");
  const [email, setEmail] = useState("");
  const [loader, setloader] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const [token, settoken] = useState(null);
  const [promoCode, setPromoCode] = useState(null);
  const [giftCode, setGiftCode] = useState(null);
  const [cardNumber, setCardNumber] = useState("");
  const [planDetails, setPlanDetails] = useState({});
  const [free_trial, setfree_trial] = useState(false);
  const [refreshtoken, setrefreshtoken] = useState(null);
  const [expirationMonth, setExpirationMonth] = useState("");
  const [expirationYear, setExpirationYear] = useState("");
  const [cardholderName, setCardholderName] = useState("");
  const [currentActiveTab, setCurrentActiveTab] = useState("2");
  const [subscriptionPlans, setSubscriptionPlans] = useState({});
  const [stripedetail, setstripedetail] = useState({});
  const [modalCardPayment, setModalCardPayment] = useState(false);
  const [modalstripecard, setmodalstripecard] = useState(false);
  const [modalPaymentDone, setModalPaymentDone] = useState(false);
  const [showPromoCodeInput, setShowPromoCodeInput] = useState(false);
  const [showGiftCodeInput, setShowGiftCodeInput] = useState(false);
  const [discountAmount, setDiscountAmount] = useState("");
  const [couponVerified, setCouponVerified] = useState(false);
  const [giftCouponVerified, setGiftCouponVerified] = useState(false);
  const [freetrialPayment, setFreetrialPayment] = useState(true);
  const [cardDetail, setCardDetail] = useState(null);
  const [activePlans, setActivePlans] = useState(null);
  const [freeTrial, setFreeTrial] = useState(null);
  const [isActiveFreeTrial, setIsActiveFreeTrial] = useState(false);
  const [zeroAmountGift, setZeroAmountGift] = useState(true);
  const [promoCodeAmount, setPromoCodeAmount] = useState(0);
  const [giftCardAmount, setGiftCardAmount] = useState(0);
  const [promocodeDetails, setPromocodeDetails] = useState(null);
  const [giftCodeDetails, setGiftCodeDetails] = useState(null);
  const { planType } = location.state || {};
  const [showform, setshowform] = useState(false);
  const [stripepromise, setstripepromise] = useState();
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [clientSecret, setClientSecret] = useState(null);
  const [options, setoptions] = useState({});
  const [upgradeModal, setupgradeModal] = useState(false);
  const [paymentMethodType, setPaymentMethodType] = useState("updateExisting");
  const [subscriptionId, setSubscriptionId] = useState(null);

  //pending 3daction
  const [customer_id, setCustomer_id] = useState(null);
  const [showPendingModal, setShowPendingModal] = useState(false);
  const [pendingAmount, setPendingAmount] = useState(null);
  const [isPendingThree, setIsPendingThree] = useState(false);
  const [paymentIntent, setPaymentIntent] = useState(null);
  const [pendingSubscription, setPendingSubscription] = useState(null);
  const [warningModal, setWarningModal] = useState(false);
  const [pendingSubscriptionId, setPendingSubscriptionId] = useState(null);
  const [inAppActivePlans, setInAppActivePlans] = useState([]);
  const [paymentDetails, setPaymentDetails] = useState({});

  //new Seamless integration modal
  const [seamlessModal, setSeamlessModal] = useState(false);
  const handleerror = (err, message = "") => {
    setloader(false);
    if (err?.response?.data?.message) {
      toast.error(`Error! ${err?.response?.data?.message}${message}`, toastobj);
    } else {
      toast.error(`Error! Something Went Wrong`, toastobj);
    }
  };

  const history = useNavigate();

  const checkSuccessSub = async (sub_id, user_id, token, type) => {
    const result = await makeThreeAttempts(sub_id, user_id, token);

    if (result === false) {
      // console.log("Failed after three attempts");
      history(`/auth/account_subscription`);
    } else {
      // console.log("Success");
      const responseData = result.data;
      if (responseData?.Subscriptions?.transaction_id) {
        history(
          `/auth/thank-you/${responseData?.Subscriptions?.transaction_id}${
            responseData?.Subscriptions?.with_free_trial ? "/freetrial" : ""
          }`,
          {
            state: {
              totalAmount: responseData?.Subscriptions?.total_amount,
            },
          }
        );
      } else {
        history(`/auth/account_subscription`);
        if (type == "upgrade") {
          toast.success(`Your plan has been upgraded`, toastobj);
        }
        if (type == "freetrial") {
          toast.success(`Subscription has been created`, toastobj);
        }
        if (type == "pending_status") {
          toast.success(`Payment completed successsfully`, toastobj);
        }
      }
    }
  };

  const fetchSubscriptionPlans = () => {
    setloader(true);
    seventhplans()
      .then((res) => {
        if (res.data.status) {
          let arr = res.data.Plans.filter((ele) => {
            return ele["show_plan"];
          });
          let obj = {};
          arr.forEach((ele) => {
            obj[ele["unique_key"]] = ele;
          });
          setSubscriptionPlans(obj);

          setloader(false);
        } else {
          toast.error("No Plans Found", toastobj);
          setloader(false);
        }
        setTimeout(() => {
          setloader(false);
        }, 1000);
      })
      .catch((err) => {
        setloader(false);
        toast.error("No Plans Found", toastobj);
      });
  };
  useEffect(() => {
    async function fetchUserInfo() {
      const { data } = await supabase.auth.getSession();
      if (data?.session?.user) {
        setEmail(data.session.user.email);
        setUserInfo(data.session.user);
        settoken(data.session.access_token);
        setrefreshtoken(data.session.refresh_token);
        const { data: entries, error4 } = await supabase
          .from("subs_additionaldetails")
          .select()
          .match({ user_id: data.session.user.id });
        if (entries.length !== 0) {
          const entry = entries[0];
          // console.log(entry.address);
          setPaymentDetails(entry);
          let tempAddres = {
            ...stripedetail,
            address: entry?.address,
            city: entry?.city,
            state: entry?.state,
            country: entry?.country,
            zip: entry?.postal_code,
            name: entry?.cardholder_name,
          };
          setstripedetail((prevState) => {
            return {
              ...prevState,
              address: entry?.address,
              city: entry?.city,
              state: entry?.state,
              country: entry?.country,
              zip: entry?.postal_code,
              name: entry?.cardholder_name,
            };
          });
        }
        getallsubscriptiondetail(
          data?.session?.user.id,
          data.session.access_token
        )
          .then((res) => {
            if (res.data.status) {
              if (res.data.Subscriptions.length > 0) {
                let customerId = null;
                for (const subscription of res.data.Subscriptions) {
                  if (
                    subscription.hasOwnProperty("inapp") &&
                    subscription?.inapp !== null &&
                    subscription?.inapp !== true
                  ) {
                    customerId = subscription.customer_id;
                    break;
                  }
                }
                setCustomer_id(customerId);
                // history("/auth/account_subscription");
                // fetchSubscriptionPlans();
                /* Object.keys(res.data.Subscriptions).forEach((i) => {
                  if (res.data.Subscriptions[i]?.["with_free_trial"]) {
                  }
                }); */
                //If any user has one subscription free trial is disabled
                setIsActiveFreeTrial(true);
              } else {
                fetchSubscriptionPlans();
              }
            } else {
              fetchSubscriptionPlans();
            }
          })
          .catch((err) => fetchSubscriptionPlans());

        getcardDetails(data.session.user.id, data.session.access_token).then(
          (res) => {
            if (res.data.status) {
              let cardData = res.data.card_details;
              setCardDetail(cardData);
            }
          }
        );
        activeSubscription(data.session.user.id, data.session.access_token)
          .then((res) => {
            if (res.data.status) {
              let arr = [];
              let arr2 = [];
              Object.keys(res.data.Subscriptions).forEach((i) => {
                if (res.data.Subscriptions[i]) {
                  let temp = res.data.Subscriptions[i];
                  if (
                    temp["activated_plan_id"] &&
                    temp.hasOwnProperty("inapp") &&
                    temp?.inapp !== null &&
                    temp?.inapp !== true
                  ) {
                    arr.push(temp);
                  } else {
                    arr2.push(temp);
                  }
                  setFreeTrial(temp["with_free_trial"]);
                  if (temp["with_free_trial"]) {
                    setIsActiveFreeTrial(temp["with_free_trial"]);
                  }
                }
              });
              setActivePlans(arr);
              setInAppActivePlans(arr2);
            }
          })
          .catch((err) => {
            if (err?.response?.data?.status_code == 404) {
              setActivePlans([]);
            }
          });
      }
    }
    fetchSubscriptionPlans();
    // setloader(true);
    fetchUserInfo();
  }, []);
  useEffect(() => {
    if (customer_id && userInfo?.id) {
      setloader(true);
      getPendingPayment(customer_id, userInfo?.id, token)
        .then((res) => {
          setloader(false);
          setPendingAmount(res?.data?.payment_intent?.amount);
          setPendingSubscription(res?.data?.payment_intent?.plan_description);
          setPendingSubscriptionId(res?.data?.payment_intent?.subscription_id);
          setPaymentIntent(res?.data?.payment_intent?.payment_intent);
          if (
            (res?.data?.payment_intent?.mode == "test" && !plan_type_prod) ||
            (res?.data?.payment_intent?.mode == "live" && plan_type_prod)
          ) {
            togglePendingModal();
          }
        })
        .catch((err) => {
          setloader(false);
          // handleerror(err);
        });
    }
  }, [customer_id, userInfo]);

  const handlePaymentMethodChange = (value) => {
    setPaymentMethodType(value);
    // console.log(paymentMethodType);
  };

  function hnadleShowPromoCode(e) {
    setShowPromoCodeInput(e.target.checked);
    setCouponVerified(false);
    setPromoCode("");
    setPromoCodeAmount(0);
    setPromocodeDetails(null);
    if (!e.target.checked) {
      if (!giftCouponVerified) {
        setDiscountAmount("");
      }
    }
    if (!showGiftCodeInput) {
      setGiftCardAmount(0);
    }
  }
  function handleShowGiftCode(e) {
    setShowGiftCodeInput(e.target.checked);
    setGiftCode("");
    setGiftCouponVerified(false);
    setGiftCardAmount(0);
    setGiftCodeDetails(null);
    if (!e.target.checked) {
      setZeroAmountGift(true);
      if (!couponVerified) {
        setDiscountAmount("");
      }
    }
    if (!showPromoCodeInput) {
      setPromoCodeAmount(0);
    }
  }

  // useEffect(() => {
  //   if (state && state.email) setEmail(state.email);
  // }, [state]);

  const toggle = (tab) => {
    if (currentActiveTab !== tab) setCurrentActiveTab(tab);
  };

  const toggleCardPayment = (sub_plan, freetrialStatus = false) => {
    if (!email) {
      args.toggleLoginModal();
      return;
    }
    /* if (checkPlanType(subscriptionPlans, sub_plan)) {
      toast.info(
        "Oops! It seems like you are trying from live id or vice versa.",
        toastobj
      );
      return;
    } */
    if (isActiveFreeTrial) {
      let check =
        checkActiveSubscription(
          subscriptionPlans,
          inAppActivePlans,
          activePlans,
          sub_plan,
          "inApp"
        ) ||
        checkActiveSubscription(
          subscriptionPlans,
          inAppActivePlans,
          activePlans,
          sub_plan,
          "stripe"
        );
      if (check) {
        return;
      }
    }
    setPlanDetails(sub_plan);
    setfree_trial(freetrialStatus);
    // setModalCardPayment(!modalCardPayment);
    togglestripemodal();
    // console.log(sub_plan);
    // console.log(cardDetail ? true : false);
  };
  const togglestripemodal = () => {
    if (!paymentDetails) {
      setstripedetail({});
    }
    setmodalstripecard(true);
  };
  const closestripemodal = (state = true) => {
    if (!paymentDetails) {
      setstripedetail({});
    }
    setmodalstripecard(false);
    setShowPromoCodeInput(false);
    setShowGiftCodeInput(false);

    setZeroAmountGift(true);

    if (state) {
      setDiscountAmount("");
      setPromoCode("");
      setGiftCode("");
      setGiftCardAmount(0);
      setPromoCodeAmount(0);
      setCouponVerified(false);
      setGiftCouponVerified(false);
      setGiftCodeDetails(null);
      setPromocodeDetails(null);
    }
  };
  const toggleUpgradeModal = (state = true) => {
    closestripemodal(false);
    // console.log(discountAmount);
    setPaymentMethodType("updateExisting");
    if (upgradeModal && state) {
      setDiscountAmount("");
      setPromoCode("");
      setGiftCode("");
      setGiftCardAmount(0);
      setPromoCodeAmount(0);
    }
    setupgradeModal(!upgradeModal);
  };

  const togglePaymentDone = () => setModalPaymentDone(!modalPaymentDone);

  const handlestripedetail = (val, name) => {
    let editdetail = { ...stripedetail };
    editdetail[name] = val;
    if (name === "country") {
      editdetail["state"] = "";
    }
    let cardAddressData = paymentDetails;
    // console.log("CardData:", cardAddressData);

    if (cardAddressData || name == "name") {
      if (
        cardAddressData?.[name] !== val ||
        (cardAddressData?.[name] !== null && val == "")
      ) {
        editdetail.changedValues = { ...editdetail.changedValues, [name]: val };
      } else {
        delete editdetail.changedValues[name];
      }
      if (name == "name" && cardAddressData?.["cardholder_name"] == val) {
        delete editdetail.changedValues[name];
      }
    }

    // console.log("StripeData:", editdetail);
    setstripedetail(editdetail);
  };

  const handleStripePayment = (type = true) => {
    if (!email) return;
    if (
      !stripedetail["name"] ||
      !stripedetail["address"] ||
      !stripedetail["city"] ||
      !stripedetail["state"] ||
      !stripedetail["country"] ||
      !stripedetail["zip"]
    ) {
      toast.error("Error! Enter all details to continue", toastobj);
      return;
    }

    //condtion to check for validity of coupons
    if (showPromoCodeInput && !couponVerified) {
      toast.error(`Invalid Promo Code`, toastobj);
      return;
    }
    if (showGiftCodeInput && !giftCouponVerified) {
      toast.error(`Invalid Gift Code`, toastobj);
      return;
    }
    setloader(true);
    const data = {
      cardholder_name: stripedetail["name"],
      subscription_plan_id: planDetails.subscription_plan_id,
      cardholder_email: email,
      address: stripedetail["address"],
      postal_code: stripedetail["zip"],
      city: stripedetail["city"],
      state: stripedetail["state"],
      country: stripedetail["country"],
      user: userInfo.id,
      with_free_trial: free_trial,
      gift_code: giftCode === null ? "" : giftCode,
      promo_code: promoCode === null ? "" : promoCode,
    };
    let name = planDetails.unique_key;
    if (name === "year_guide" || name === "month_guide") {
      data["SeventhGuide"] = true;
    } else if (name === "year_arc" || name === "month_arc") {
      data["SeventhArc"] = true;
    } else if (name === "year_sight" || name === "month_sight") {
      data["SeventhSight"] = true;
    } else if (name === "year_journal" || name === "month_journal") {
      data["seventhjournal"] = true;
    } else if (name === "year_all" || name === "month_all") {
      data["seventhjournal"] = true;
      data["SeventhArc"] = true;
      data["SeventhSight"] = true;
      data["SeventhGuide"] = true;
    }

    if (isActiveFreeTrial) {
      let check =
        checkActiveSubscription(
          subscriptionPlans,
          inAppActivePlans,
          activePlans,
          planDetails,
          "inApp"
        ) ||
        checkActiveSubscription(
          subscriptionPlans,
          inAppActivePlans,
          activePlans,
          planDetails,
          "stripe"
        );
      if (check) {
        setloader(false);
        return;
      }
    }

    if (cardDetail && type) {
      // updateSubscription(data);
      setloader(false);
      const isBetaTester = activePlans.some(
        (subscription) => subscription.beta_tester
      );
      if (isBetaTester) {
        toast.error(
          "Active plan includes this subscription features",
          toastobj
        );
        closestripemodal(true);
        return;
      }
      toggleUpgradeModal(false);
    } else if (
      cardDetail === null &&
      isActiveFreeTrial &&
      customer_id &&
      type
    ) {
      // console.log("396-------> ");
      const subscriptionPlanId = planDetails.subscription_plan_id;
      let arrOfOtherSubs = [];

      // Check if the activated plan is the same as the subscription plan
      if (activePlans.length > 0) {
        let flag = true;
        const activatedPlanIds = activePlans.map(
          (subscription) => subscription.activated_plan_id
        );
        activePlans.some((element) => {
          if (element.activated_plan_id === subscriptionPlanId && flag) {
            toast.error("Plan is already active", toastobj);
            setloader(false);
            flag = false;
            return; // This will exit the some loop when a match is found
          }
          if (element.activated_plan_id === "prod_beta_tester") {
            toast.error(
              "Active plan includes this subscription features",
              toastobj
            );
            setloader(false);
            flag = false;
            return true; // This will exit the some loop when a match is found
          }
          return; // Continue iterating if no match is found
        });

        if (!flag) {
          return;
        }
        let unique_1;
        let unique_2;

        for (const key in subscriptionPlans) {
          const plan = subscriptionPlans[key];

          // Check if the subscription plan ID matches the target ID
          if (plan.subscription_plan_id === subscriptionPlanId) {
            // If there is a match, store it in the new object with a unique key
            unique_1 = plan.unique_key;
          }
          activatedPlanIds.map((element) => {
            if (plan.subscription_plan_id === element) {
              // If there is a match, store it in the new object with a unique key
              unique_2 = plan.unique_key;
            }
          });
        }
        // console.log(unique_1 + "---" + unique_2);
        if (unique_1 && unique_2) {
          if (unique_2 === "year_all") {
            toast.error("Plan is already active", toastobj);
            setloader(false);
            flag = false;
            return;
          } else if (
            unique_2.split("_")[1] === "all" &&
            unique_2 === "month_all" &&
            unique_1 !== "year_all"
          ) {
            toast.error(
              "Active plan includes this subscription features",
              toastobj
            );
            setloader(false);
            flag = false;
            return;
          } else {
          }
        }
        if (!flag) {
          return;
        }
      }
      handleUpgradeFreeTrial();
    } else {
      createstripepayment(data);
    }
  };

  const createstripepayment = (data) => {
    const formData = new FormData();
    formData.append("data", JSON.stringify(data));
    const newUUID = uuidv4();

    createStripeSubscription(formData, token)
      .then((res) => {
        if (res.data.status) {
          if (res.data.client_secret) {
            let stripesenddetail = {
              clientSecret: res.data.client_secret,
              publishkey: res.data.publishableKey,
              ephemeralKey: res.data.ephemeralKey,
              customer: res.data.customer,
              subscription_id: res.data.subscription.subscription_id,
              total_amount:
                discountAmount !== "" && discountAmount >= 0
                  ? Number(discountAmount).toFixed(2)
                  : planDetails?.percentage_off > 0
                  ? planDetails.special_price
                  : planDetails.price,
            };

            let temp = {
              unique_key: newUUID,
              json: JSON.stringify(stripesenddetail),
              created_at: new Date().toISOString(),
              updated_at: new Date().toISOString(),
              t_type: "subscription",
            };
            // console.log(temp);
            insertTempDetails(temp, newUUID, "2", res);
          } else {
            if (res.data.beta_testing) {
              checkSuccessSub(
                res.data.subscription.subscription_id,
                userInfo.id,
                token,
                "freetrial"
              );
            } else {
              let stripesenddetail = {
                total_amount:
                  discountAmount !== "" && discountAmount >= 0
                    ? Number(discountAmount).toFixed(2)
                    : planDetails?.percentage_off > 0
                    ? planDetails.special_price
                    : planDetails.price,
              };
              if (freetrialPayment) {
                stripesenddetail = {
                  total_amount: 0,
                };
              }
              let existingSenderData = localStorage.getItem("stripe_details");
              if (!freetrialPayment) {
                checkSuccessSub(
                  res?.data?.subscription?.subscription_id,
                  userInfo.id,
                  token,
                  "freetrial"
                );
                /* setTimeout(() => {
                  setloader(false);
                  history("/auth/account_subscription");
                }, [5000]); */
              } else {
                setloader(false);

                localStorage.setItem(
                  "stripe_details",
                  JSON.stringify(stripesenddetail)
                );

                history(
                  `/auth/paymentupdate/create/${refreshtoken}/${res.data.customer}`
                );
              }
            }
          }
        } else {
          toast.error(`Error! ${res.data.message}`, toastobj);
          setloader(false);
        }
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          toast.error(`Error! ${err?.response?.data?.message}`, toastobj);
        } else {
          toast.error(`Error! Something Went Wrong`, toastobj);
        }
        setloader(false);
      });
  };
  const handlePayment = async () => {
    if (!email) return;
    if (
      !cardholderName ||
      !expirationMonth ||
      !expirationYear ||
      !cardNumber ||
      !cvv
    ) {
      toast.error("Error! Enter all details to continue", toastobj);
      return;
    }

    setloader(true);
    const data = {
      cardholder_name: cardholderName,
      subscription_plan_id: planDetails.subscription_plan_id,
      card_expiry_month: expirationMonth,
      card_expiry_year: expirationYear,
      user: userInfo.id,
      card_number: getcardnumberforapi(cardNumber),
      card_cvv: cvv,
      cardholder_email: email,
    };
    let name = planDetails.unique_key;
    if (name === "year_guide" || name === "month_guide") {
      data["SeventhGuide"] = true;
    } else if (name === "year_arc" || name === "month_arc") {
      data["SeventhArc"] = true;
    } else if (name === "year_sight" || name === "month_sight") {
      data["SeventhSight"] = true;
    } else if (name === "year_journal" || name === "month_journal") {
      data["seventhjournal"] = true;
    } else if (name === "year_all" || name === "month_all") {
      data["seventhjournal"] = true;
      data["SeventhArc"] = true;
      data["SeventhSight"] = true;
      data["SeventhGuide"] = true;
    }
    if (showPromoCodeInput && promoCode) {
      let headers = {};
      if (JSON.parse(localStorage.getItem(""))) {
        let user = JSON.parse(localStorage.getItem("sevensight_user"));
        headers = { Authorization: `Bearer ${user["token"]}` };
      }
      const promoresponse = await fetch(
        `${payment_url}/subsapp/coupon_check?coupon=${promoCode}&subscription=${planDetails.unique_key}`,
        {
          headers,
        }
      );
      const promoData = await promoresponse.json();

      if (!promoData.status) {
        toast.error(`Error! Invalid Promo Code`, toastobj);
        setPromoCode("");
        setloader(false);
        return;
      } else {
        data.coupon = promoCode;
      }
    }

    const formData = new FormData();
    formData.append("data", JSON.stringify(data));

    createSubscription(formData, token)
      .then((res) => {
        if (res.data.status) {
          toast.success(`Success! ${res.data.message}`, toastobj);
          togglePaymentDone();
          setModalCardPayment(!modalCardPayment);
          history("/auth/account_subscription");
        } else {
          toast.error(`Error! ${res.data.message}`, toastobj);
        }
        setloader(false);
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          toast.error(`Error! ${err?.response?.data?.message}`, toastobj);
        } else {
          toast.error(`Error! Something Went Wrong`, toastobj);
        }
        setloader(false);
      });
  };
  const toggleSeamlessModal = () => {
    setSeamlessModal(!seamlessModal);
  };

  const VerifyPromoCode = (val) => {
    const formData = new FormData();
    formData.append("coupon", val);
    formData.append("subscription", planDetails.unique_key);
    couponCheckNew(formData)
      .then((res) => {
        if (res.data.status) {
          if (res.data?.beta_testing && inAppActivePlans.length > 0) {
            toast.info(
              "To upgrade this subscription you have to cancel inApp subscription from app store.",
              toastobj
            );
          } else {
            setPromocodeDetails(res.data);
            setCouponVerified(res.data.status);
          }
          /* if (res.data.discount_percentage) {
        
            let temp =
              planDetails?.percentage_off > 0
                ? planDetails.special_price
                : planDetails.price;
            temp = Number(
              temp - (res.data.discount_percentage / 100) * temp
            ).toFixed(2);
            setDiscountAmount(temp);
            setPromoCodeAmount(
              Number(
                (planDetails?.percentage_off > 0
                  ? planDetails.special_price
                  : planDetails.price) - temp
              ).toFixed(2)
            );
          }
          if (res.data.discount_amount) {
            let temp =
              planDetails?.percentage_off > 0
                ? planDetails.special_price
                : planDetails.price;
            if (res.data.discount_amount > temp) {
              temp = 0;
              setPromoCodeAmount(
                planDetails?.percentage_off > 0
                  ? planDetails.special_price
                  : planDetails.price
              );
            } else {
              temp = Number(temp - res.data.discount_amount).toFixed(2);
              setPromoCodeAmount(res.data.discount_amount);
            }
            setDiscountAmount(temp);
          } */
        }
      })
      .catch((err) => {
        setCouponVerified(false);
        setPromoCodeAmount(0);
        setPromocodeDetails(null);
      });
  };
  const VerifyGiftCode = (val) => {
    let newFormData = new FormData();
    newFormData.append("gift_code", val);

    giftCouponCheck(newFormData)
      .then((res) => {
        if (res.data.status) {
          setGiftCodeDetails(res.data);
          setGiftCouponVerified(res.data.status);
        }
      })
      .catch((err) => {
        if (!couponVerified) {
          let temp =
            planDetails?.percentage_off > 0
              ? planDetails.special_price
              : planDetails.price;
          setDiscountAmount(temp - promoCodeAmount);
        } else {
          setDiscountAmount("");
        }
        setGiftCouponVerified(false);
        setZeroAmountGift(true);
        setGiftCardAmount(0);
        setGiftCodeDetails(null);
        if (err?.response?.status === 401) {
          toast.error(`${err?.response?.data?.message}`, toastobj);
        }
      });
  };
  useEffect(() => {
    if (couponVerified) {
      document.onkeydown = () => false;
      setloader(true);
      setTimeout(() => {
        setloader(false);
        document.onkeydown = () => true;
      }, 750);
    }
  }, [couponVerified]);
  useEffect(() => {
    if (giftCouponVerified) {
      document.onkeydown = () => false;
      setloader(true);
      setTimeout(() => {
        setloader(false);
        document.onkeydown = () => true;
      }, 750);
    }
  }, [giftCouponVerified]);
  useEffect(() => {
    //condition if user enters first coupon then gift
    let price =
      planDetails?.percentage_off > 0
        ? planDetails.special_price
        : planDetails.price;
    if (couponVerified && giftCouponVerified) {
      let a, b;
      if (giftCodeDetails?.discount_amount) {
        a = giftCodeDetails.discount_amount;
      }
      if (promocodeDetails?.discount_amount) {
        b = promocodeDetails.discount_amount;
      }
      if (promocodeDetails?.discount_percentage) {
        b = Number(
          (promocodeDetails.discount_percentage / 100) * (price - a)
        ).toFixed(2);
        // console.log(b);
      }
      setGiftCardAmount(a);
      setPromoCodeAmount(b);
      checkGiftExceedsPrice(a, b);
    }
    if (couponVerified && !giftCouponVerified) {
      let b;
      if (promocodeDetails?.discount_amount) {
        b = promocodeDetails.discount_amount;
      }
      if (promocodeDetails?.discount_percentage) {
        b = Number(
          (promocodeDetails.discount_percentage / 100) * price
        ).toFixed(2);
      }
      setPromoCodeAmount(b);
      setDiscountAmount(Number(price - b).toFixed(2));
    }
    if (!couponVerified && giftCouponVerified) {
      let a;
      if (giftCodeDetails?.discount_amount) {
        a = giftCodeDetails.discount_amount;
      }
      /* if (giftCodeDetails?.discount_percentage) {
        b = Number((giftCodeDetails.discount_percentage / 100) * price).toFixed(
          2
        );
      } */
      setGiftCardAmount(a);
      checkGiftExceedsPrice(a, 0);
    } else if (!couponVerified && !giftCouponVerified) {
      setDiscountAmount("");
    }
  }, [giftCodeDetails, promocodeDetails]);
  const checkGiftExceedsPrice = (a, b) => {
    //this function is to handle cost if gift card redeem amount exceeds cost
    if (giftCodeDetails?.discount_amount) {
      let temp =
        planDetails?.percentage_off > 0
          ? planDetails.special_price
          : planDetails.price;
      if (giftCodeDetails.discount_amount >= temp) {
        temp = 0;
        setZeroAmountGift(false);
        setCouponVerified(false);
        setPromoCode("");
        setShowPromoCodeInput(false);
        setGiftCardAmount(
          planDetails?.percentage_off > 0
            ? planDetails.special_price
            : planDetails.price
        );
        setPromoCodeAmount(0);
      } else {
        // console.log(promoCodeAmount);
        temp = Number(temp - giftCodeDetails.discount_amount - b).toFixed(2);
        setGiftCardAmount(giftCodeDetails.discount_amount);
        setZeroAmountGift(true);
      }
      // console.log(temp);
      setDiscountAmount(temp);
    }
  };

  const handleFreetrialGiftPayment = async () => {
    /* this function is called whenever there is free
     trial with payment or gift card amount zero */

    if (!email) return;
    if (
      !stripedetail["name"] ||
      !stripedetail["address"] ||
      !stripedetail["zip"] ||
      !stripedetail["city"] ||
      !stripedetail["state"] ||
      !stripedetail["country"]
    ) {
      toast.error("Error! Enter all details to continue", toastobj);
      return;
    }
    if (promoCode && !couponVerified) {
      toast.error(`Invalid Promo Code`, toastobj);
      return;
    }
    if (giftCode && !giftCouponVerified) {
      toast.error(`Invalid Gift Coupon Code`, toastobj);
      return;
    }
    setloader(true);
    const data = {
      cardholder_name: stripedetail["name"],
      subscription_plan_id: planDetails.subscription_plan_id,
      cardholder_email: email,
      address: stripedetail["address"],
      postal_code: stripedetail["zip"],
      city: stripedetail["city"],
      state: stripedetail["state"],
      country: stripedetail["country"],
      user: userInfo.id,
      with_free_trial: free_trial,
      promo_code: couponVerified ? promoCode : "",
      gift_code: giftCouponVerified ? giftCode : "",
    };
    // console.log(data);
    const newUUID = uuidv4();
    let name = planDetails.unique_key;
    if (name === "year_guide" || name === "month_guide") {
      data["SeventhGuide"] = true;
    } else if (name === "year_arc" || name === "month_arc") {
      data["SeventhArc"] = true;
    } else if (name === "year_sight" || name === "month_sight") {
      data["SeventhSight"] = true;
    } else if (name === "year_journal" || name === "month_journal") {
      data["seventhjournal"] = true;
    } else if (name === "year_all" || name === "month_all") {
      data["seventhjournal"] = true;
      data["SeventhArc"] = true;
      data["SeventhSight"] = true;
      data["SeventhGuide"] = true;
    }
    // check for beta coupon
    let tempCheck =
      showPromoCodeInput && promoCode && discountAmount.toString() === "0.00";
    if (cardDetail || tempCheck) {
      if (tempCheck && activePlans.length == 0 && customer_id == null) {
        // console.log("11111");
        handleStripePayment(false);
      } else {
        updateSubscription(tempCheck);
      }
    } else if (cardDetail === null && activePlans?.length > 0) {
      handleUpgradeFreeTrial(false);
    } else {
      const formData = new FormData();
      formData.append("cardholder_email", email);
      formData.append("cardholder_name", stripedetail["name"]);
      formData.append("address", stripedetail["address"]);
      formData.append("postal_code", stripedetail["zip"]);
      formData.append("city", stripedetail["city"]);
      formData.append("state", stripedetail["state"]);
      formData.append("country", stripedetail["country"]);

      updateStripePayment(formData, token)
        .then((res) => {
          if (res.data.status) {
            let newDetails = {
              data,
              paymentDetails: res.data,
              freeTrial: free_trial
                ? { status: true, days: args.noFreeTrialDays }
                : {},
              firstZeroGift:
                (!showPromoCodeInput &&
                  giftCode !== null &&
                  discountAmount === 0) ||
                false,
            };
            let temp = {
              unique_key: newUUID,
              json: JSON.stringify(newDetails),
              created_at: new Date().toISOString(),
              updated_at: new Date().toISOString(),
              t_type: "subscription",
            };
            // console.log(temp);
            insertTempDetails(temp, newUUID, "1", res);
          }
        })
        .catch((err) => {
          setloader(false);
          toast.error("Somthing went wrong");
        });
    }
  };
  const insertTempDetails = async (temp, newUUID, type = "1", res) => {
    const { newdata, error } = await supabase
      .from("subs_temsubscription")
      .insert(temp)
      .select();
    if (error) {
      setloader(false);
      toast.error("Somthing went wrong");
    } else {
      // setloader(false);
      /* if (discountAmount === 0) { */
      let name = planDetails.unique_key;
      let arr = name.split("_");
      if (type == "2") {
        history(`/auth/stripepayment/${refreshtoken}/${newUUID}`);
      } else {
        history(
          `/auth/freeTrialGift/${refreshtoken}/${res.data.customer}/${newUUID}`,
          {
            state: {
              giftCouponVerified: true,
              typeOfSub: arr[0],
              amountOfSub: discountAmount,
            },
          }
        );
      }
      /* } else {
        history(
          `/auth/freeTrialGift/${refreshtoken}/${res.data.customer}/${newUUID}`,
          {
            state: {
              giftCouponVerified: false,
              typeOfSub: "",
              amountOfSub: 0,
            },
          }
        );
      } */
    }
  };
  const handleUpgradeFreeTrial = async (type = true) => {
    /* this function is called whenever there is free
     trial,no card details and user tries to upgrade subscription */

    setloader(true);
    let data = {
      new_subscription_plan_id: planDetails.subscription_plan_id,
      user: userInfo.id,
      with_free_trial: free_trial,
      other_subscriptions: [],
      promo_code: couponVerified ? promoCode : "",
      gift_code: giftCouponVerified ? giftCode : "",
      email: email,
    };
    if (
      stripedetail?.changedValues &&
      Object.keys(stripedetail?.changedValues).length > 0
    ) {
      data = { ...data, ...stripedetail.changedValues };
    }
    data = {
      ...data,
      cardholder_name: data?.name,
      postal_code: data?.zip,
      name: undefined,
      zip: undefined,
    };
    delete data.name;
    delete data.zip;
    // console.log(data);
    const newUUID = uuidv4();

    let customerId;
    const subscriptionPlanId = planDetails.subscription_plan_id;
    let arrOfOtherSubs = [];
    if (activePlans.length > 0) {
      /* data["other_subscriptions"].push(activePlans[0]["subscription_id"]);*/
      customerId = activePlans[0]?.["customer_id"];
      data["customer_id"] = customerId;
      let flag = true;
      const activatedPlanIds = activePlans.map(
        (subscription) => subscription.activated_plan_id
      );

      /* let unique_1;
      let unique_2;

      for (const key in subscriptionPlans) {
        const plan = subscriptionPlans[key];

        // Check if the subscription plan ID matches the target ID
        if (plan.subscription_plan_id === subscriptionPlanId) {
          // If there is a match, store it in the new object with a unique key
          unique_1 = plan.unique_key;
        }
        activatedPlanIds.map((element) => {
          if (plan.subscription_plan_id === element) {
            // If there is a match, store it in the new object with a unique key
            unique_2 = plan.unique_key;
          }
        });
      } */

      //active subscription plan id
      // console.log(activatedPlanIds);
      const matchedSubscriptions = {};
      const matchedSubscriptionsTwo = {};
      const subscriptionId = {};
      for (const key in subscriptionPlans) {
        const plan = subscriptionPlans[key];

        // Check if the subscription plan ID matches the target ID
        if (plan.subscription_plan_id === subscriptionPlanId) {
          // If there is a match, store it in the new object with a unique key
          matchedSubscriptionsTwo[plan.unique_key] = plan.subscription_plan_id;
        }
        activatedPlanIds.map((element) => {
          if (plan.subscription_plan_id === element) {
            // If there is a match, store it in the new object with a unique key
            matchedSubscriptions[plan.unique_key] = plan.subscription_plan_id;
          }
        });
      }
      // console.log(matchedSubscriptions);
      // console.log(matchedSubscriptionsTwo);

      for (const key in matchedSubscriptionsTwo) {
        let plan_key = key.split("_");
        for (const subkey in matchedSubscriptions) {
          let subscribedKey = subkey.split("_");
          if (plan_key[1] === subscribedKey[1]) {
            let temp = [];
            activePlans.map((element) => {
              if (element.activated_plan_id === matchedSubscriptions[subkey]) {
                data["other_subscriptions"].push(element.subscription_id);
              }
            });
          }
        }
      }

      // body["other_subscriptions"] = newtemp;
      // console.log(body["other_subscriptions"]);
      for (const key in matchedSubscriptionsTwo) {
        // Check if the key has the format 'something_all'
        if (key.includes("_all")) {
          data["other_subscriptions"] = [];
          for (const key2 in matchedSubscriptions) {
            activePlans.map((element) => {
              if (element.activated_plan_id === matchedSubscriptions[key2]) {
                data["other_subscriptions"].push(element.subscription_id);
              }
            });
          }
        }
      }
      // console.log(body["other_subscriptions"]);
    } else {
      customerId = customer_id;
      data["customer_id"] = customer_id;
    }

    let name = planDetails["unique_key"];
    if (name === "year_guide" || name === "month_guide") {
      data["SeventhGuide"] = true;
    } else if (name === "year_arc" || name === "month_arc") {
      data["SeventhArc"] = true;
    } else if (name === "year_sight" || name === "month_sight") {
      data["SeventhSight"] = true;
    } else if (name === "year_journal" || name === "month_journal") {
      data["seventhjournal"] = true;
    } else if (name === "year_all" || name === "month_all") {
      data["SeventhArc"] = true;
      data["SeventhSight"] = true;
      data["SeventhGuide"] = true;
      data["seventhjournal"] = true;
    }

    // console.log(data);
    const temp = {
      unique_key: newUUID,
      json: type
        ? JSON.stringify({ ...data, totalAmount: returnAmount() })
        : JSON.stringify(data),
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
      t_type: "subscription",
    };
    insertTempDetailsNew(temp, customerId, newUUID, type);
  };

  //type is to handle if user doesnt have any card and tries from zero gift card discount
  const updateSubscription = (type = false) => {
    setloader(true);
    let body = {
      new_subscription_plan_id: planDetails["subscription_plan_id"],
      customer_id: cardDetail ? cardDetail?.["customer_id"] : customer_id,
      email: email,
      user: userInfo.id,
      other_subscriptions: [],
      with_free_trial: free_trial,
      promo_code: promoCode !== null ? promoCode : "",
      gift_code: giftCode !== null ? giftCode : "",
    };
    if (
      stripedetail?.changedValues &&
      Object.keys(stripedetail?.changedValues).length > 0
    ) {
      body = { ...body, ...stripedetail.changedValues };
    }
    body = {
      ...body,
      cardholder_name: body?.name,
      postal_code: body?.zip,
      name: undefined,
      zip: undefined,
    };
    delete body.name;
    delete body.zip;
    // let customerId = activePlans[0]["customer_id"];
    const subscriptionPlanId = planDetails.subscription_plan_id;
    let arrOfOtherSubs = [];

    // Check if the activated plan is the same as the subscription plan
    if (activePlans?.length > 0) {
      let flag = true;
      const activatedPlanIds = activePlans.map(
        (subscription) => subscription.activated_plan_id
      );
      activePlans.some((element) => {
        if (element.activated_plan_id === subscriptionPlanId && flag) {
          toast.error("Plan is already active", toastobj);
          setloader(false);
          flag = false;
          return;
        }
        if (element.activated_plan_id === "prod_beta_tester") {
          toast.error(
            "Active plan includes this subscription features",
            toastobj
          );
          setloader(false);
          flag = false;
          return true;
        }
        return false;
      });

      if (!flag) {
        return;
      }
      let unique_1;
      let unique_2;

      for (const key in subscriptionPlans) {
        const plan = subscriptionPlans[key];

        // Check if the subscription plan ID matches the target ID
        if (plan.subscription_plan_id === subscriptionPlanId) {
          // If there is a match, store it in the new object with a unique key
          unique_1 = plan.unique_key;
        }
        activatedPlanIds.map((element) => {
          if (plan.subscription_plan_id === element) {
            // If there is a match, store it in the new object with a unique key
            unique_2 = plan.unique_key;
          }
        });
      }

      if (unique_1 && unique_2) {
        if (unique_2 === "year_all") {
          toast.error("Plan is already active", toastobj);
          setloader(false);
          flag = false;
          return;
        } else if (
          unique_2.split("_")[1] === "all" &&
          unique_2 === "month_all" &&
          unique_1 !== "year_all"
        ) {
          toast.error(
            "Active plan includes this subscription features",
            toastobj
          );
          setloader(false);
          flag = false;
          return;
        } else {
        }
      }
      if (!flag) {
        return;
      }

      const matchedSubscriptions = {};
      const matchedSubscriptionsTwo = {};
      const subscriptionId = {};
      for (const key in subscriptionPlans) {
        const plan = subscriptionPlans[key];

        // Check if the subscription plan ID matches the target ID
        if (plan.subscription_plan_id === subscriptionPlanId) {
          // If there is a match, store it in the new object with a unique key
          matchedSubscriptionsTwo[plan.unique_key] = plan.subscription_plan_id;
        }
        activatedPlanIds.map((element) => {
          if (plan.subscription_plan_id === element) {
            // If there is a match, store it in the new object with a unique key
            matchedSubscriptions[plan.unique_key] = plan.subscription_plan_id;
          }
        });
      }

      for (const key in matchedSubscriptionsTwo) {
        let plan_key = key.split("_");
        for (const subkey in matchedSubscriptions) {
          let subscribedKey = subkey.split("_");
          if (plan_key[1] === subscribedKey[1]) {
            let temp = [];
            activePlans.map((element) => {
              if (element.activated_plan_id === matchedSubscriptions[subkey]) {
                body["other_subscriptions"].push(element.subscription_id);
              }
            });
          }
        }
      }

      for (const key in matchedSubscriptionsTwo) {
        // Check if the key has the format 'something_all'
        if (key.includes("_all")) {
          body["other_subscriptions"] = [];
          for (const key2 in matchedSubscriptions) {
            activePlans.map((element) => {
              if (element.activated_plan_id === matchedSubscriptions[key2]) {
                body["other_subscriptions"].push(element.subscription_id);
              }
            });
          }
        }
      }
    }

    let name = planDetails["unique_key"];
    if (name === "year_guide" || name === "month_guide") {
      body["SeventhGuide"] = true;
    } else if (name === "year_arc" || name === "month_arc") {
      body["SeventhArc"] = true;
    } else if (name === "year_sight" || name === "month_sight") {
      body["SeventhSight"] = true;
    } else if (name === "year_journal" || name === "month_journal") {
      body["seventhjournal"] = true;
    } else if (name === "year_all" || name === "month_all") {
      body["SeventhArc"] = true;
      body["SeventhSight"] = true;
      body["SeventhGuide"] = true;
      body["seventhjournal"] = true;
    }
    if (paymentMethodType === "updateExisting" || type) {
      setupgradeModal(false);
      updatePlan(body, token)
        .then((res) => {
          if (res.data.status) {
            setSubscriptionId(res?.data?.subscription_details?.subscription_id);
            if (res?.data?.client_secret) {
              setshowform(true);
              setstripepromise(loadStripe(res?.data?.publishableKey));
              setClientSecret(res?.data?.client_secret);
              setPaymentMethod(res?.data?.payment_method);
              setoptions({
                clientSecret: res?.data?.client_secret,
                appearance: stripeAppearance,
              });
            } else {
              toast.success(`${res.data.message}`, toastobj);
              checkSuccessSub(
                res?.data?.subscription_details?.subscription_id,
                userInfo.id,
                token,
                "upgrade"
              );
              /* setTimeout(() => {
                setloader(false);
                history("/auth/account_subscription");
              }, [3000]); */
            }
          } else {
            toast.error(`Error! ${res.data.message}`, toastobj);
            setloader(false);
          }
        })
        .catch((err) => handleerror(err));
    } else {
      const newUUID = uuidv4();
      body["totalAmount"] =
        discountAmount >= 0 && discountAmount !== ""
          ? discountAmount
          : planDetails?.percentage_off > 0
          ? planDetails.special_price
          : planDetails.price;
      let temp = {
        unique_key: newUUID,
        json: JSON.stringify(body),
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
        t_type: "subscription",
      };
      //special case if user only takes subscriptions with gift card complete discount
      insertTempDetailsNew(temp, body["customer_id"], newUUID);
    }
  };
  const insertTempDetailsNew = async (
    temp,
    customerId,
    newUUID,
    type = true
  ) => {
    // console.log(giftCouponVerified);
    const { newdata, error } = await supabase
      .from("subs_temsubscription")
      .insert(temp)
      .select();
    if (error) {
      setloader(false);
      toast.error("Somthing went wrong");
    } else {
      setloader(false);

      let name = planDetails.unique_key;
      let arr = name.split("_");

      history(
        `/auth/paymentupdate/freetrialpaymentupdate/${refreshtoken}/${customerId}/${newUUID}`,
        {
          state: {
            giftCouponVerified: type ? false : giftCouponVerified,
            typeOfSub: type ? "" : arr[0],
            amountOfSub: returnAmount(),
          },
        }
      );
    }
  };
  useEffect(() => {
    if (planType && planType.planName && !planType.status) {
      toast.error(
        `Oops! It seems like you are not subscribed to ${planType.planName} plan.`,
        toastobj
      );
    }
  }, [planType]);

  const toggleLoader = () => {
    if (loader && !isPendingThree) {
      checkSuccessSub(subscriptionId, userInfo.id, token, "upgrade");
      /* setTimeout(() => {
        setloader(false);
        toast.success(`Your plan has been upgraded`, toastobj);
        history("/auth/account_subscription");
      }, 3000); */
    } else {
      removePendingStatus();
    }
  };

  const toggleCancel = (type = "others") => {
    if (loader) {
      closestripemodal();
      setloader(false);
      removePendingStatus();
    }
  };
  const returnAmount = () => {
    return free_trial
      ? 0
      : discountAmount !== "" && discountAmount >= 0
      ? parseFloat(discountAmount) // Assuming discountAmount is a string that needs to be converted to a number
      : planDetails?.percentage_off > 0
      ? parseFloat(planDetails.special_price)
      : parseFloat(planDetails.price);
  };
  const handlePendingPayment = () => {
    // console.log(pendingAmount);
    setloader(true);
    let newData = new FormData();
    newData.append("user", userInfo?.id);
    newData.append("customer_id", customer_id);
    getThreeDIncomplete(newData, token)
      .then((res) => {
        setIsPendingThree(true);
        setshowform(true);
        setstripepromise(loadStripe(res?.data?.publishableKey));
        setClientSecret(res?.data?.payment_intent?.client_secret);
        setPaymentMethod(res?.data?.payment_intent?.payment_method);
        setPaymentIntent(res?.data?.payment_intent?.payment_intent);
        setoptions({
          clientSecret: res?.data?.payment_intent?.client_secret,
          appearance: stripeAppearance,
        });
      })
      .catch((err) => {
        setloader(false);
        togglePendingModal();
        handleerror(err);
      });
  };
  let removePendingStatusCalled = false;
  function removePendingStatus(flag = true) {
    if (!removePendingStatusCalled) {
      setloader(true);

      let newData = new FormData();
      newData.append("user", userInfo?.id);
      newData.append("customer_id", customer_id);
      newData.append("payment_intent", paymentIntent);

      getAfterSuccessThreeD(newData, token)
        .then((res) => {
          setloader(false);
          // toast.success(`Payment was successful`, toastobj);
          if (flag) {
            checkSuccessSub(
              pendingSubscriptionId,
              userInfo.id,
              token,
              "pending_status"
            );
          } else {
            setloader(false);
          }
        })
        .catch((err) => {
          setloader(false);
          handleerror(err);
        });
      removePendingStatusCalled = true;
    }
  }
  const togglePendingModal = (flag = false) => {
    if (flag) {
      removePendingStatus(false);
    }
    setShowPendingModal(!showPendingModal);
  };
  const togglePendingWarningModal = (flag = false) => {
    if (flag) {
      removePendingStatus(false);
    }
    setWarningModal(!warningModal);
  };
  useEffect(() => {
    if (promoCode !== null) {
      VerifyPromoCode(promoCode);
    }
  }, [promoCode]);
  useEffect(() => {
    if (giftCode !== null) {
      VerifyGiftCode(giftCode);
    }
  }, [giftCode]);

  return (
    <div className="buygift_main">
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div
        onClick={() => {
          args.toggleMenu();
        }}
      >
        {!loader && (
          <Container>
            <Row>
              <Col>&nbsp;</Col>
            </Row>
            <Row className=" mb-5">
              <Col md="8" className="">
                <h2>
                  Our <span>Pricing Plans</span>
                </h2>
                <p className="main-text-color-new">
                  Unlock the full potential of your inner world with our
                  exclusive subscription designed to guide you through a
                  transformative journey of self-discovery and wellbeing.
                </p>
                <p className="main-text-color-new">
                  Our AI-powered dream analysis dives deep into the symbolism of
                  your dreams, offering insightful interpretations and
                  personalized guidance. Complement this with our intuitive
                  journaling feature, where AI coaching turns your reflections
                  into actionable steps towards personal growth. Experience
                  holistic support with our professional counseling sessions,
                  tailored personality tests, and soothing guided meditations.
                </p>
                <p className="main-text-color-new">
                  Don’t just dream; thrive and evolve with us as your dedicated
                  partner in self-exploration and mental wellness.
                </p>
                <p style={{ fontWeight: "700" }}>
                  Early Access Special: Be the First to Explore and with
                  Exclusive Savings!
                </p>
              </Col>
            </Row>
            <Row className="paddingbottom50 home-tabs create_subs">
              <Col>
                <Nav tabs className="mb-5 pointer">
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: currentActiveTab === "1",
                      })}
                      onClick={() => {
                        toggle("1");
                      }}
                    >
                      Monthly
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: currentActiveTab === "2",
                      })}
                      onClick={() => {
                        toggle("2");
                      }}
                    >
                      Yearly
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={currentActiveTab}>
                  <TabPane tabId="1">
                    <div>
                      <Swiper loop {...PricingPlanCarouselSetting}>
                        <SwiperSlide key={1}>
                          <Col md="12">
                            <div className="hp-pricing-box  ">
                              <div
                                className="hp-bundle-ribbon"
                                data-ribbon="BUNDLE"
                                // style={'--d:0px;--c:orange;--f:25px;'}
                              ></div>
                              <img
                                src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/hp-integrated-package.png?t=2024-01-10T04%3A14%3A20.090Z"
                                alt=""
                              />
                              <div
                                className={`hp-pricing-box-cont hp-pricing-box-cont-bg3 hp-pricing-box-cont-bg3-new${
                                  isActiveFreeTrial ? "-not-free-monthly" : ""
                                }`}
                              >
                                <div className="flexColStart al-center">
                                  <h5>INTEGRATED PACKAGE</h5>
                                  {subscriptionPlans["month_all"]
                                    ?.percentage_off > 0 &&
                                  subscriptionPlans["month_all"].show_plan ? (
                                    <div className="flexRowStart cg-05">
                                      <h4>
                                        $
                                        {formatNumber(
                                          subscriptionPlans["month_all"]
                                            ?.special_price
                                        )}
                                      </h4>
                                      <h5 className="striked-discount-price">
                                        <s>
                                          $
                                          {
                                            subscriptionPlans["month_all"]
                                              ?.price
                                          }
                                        </s>
                                      </h5>
                                    </div>
                                  ) : (
                                    <div className="flexRowStart cg-05">
                                      <h4>
                                        ${subscriptionPlans["month_all"]?.price}
                                      </h4>
                                    </div>
                                  )}
                                </div>

                                <div
                                  className="flexColStart w-100 rg-05"
                                  style={{
                                    marginBottom: "16px",
                                  }}
                                >
                                  <div className="flexRowStart  w-100 al-center">
                                    <img
                                      style={{
                                        width: "16px",
                                        height: "16px",
                                      }}
                                      src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/icon-tick-green.png"
                                      alt="icon"
                                    />
                                    <h6
                                      style={{
                                        margin: "0",
                                      }}
                                    >
                                      AI Powered Unlimited Dream Analysis
                                    </h6>
                                  </div>
                                  <div className="flexRowStart  w-100 al-center">
                                    <img
                                      style={{
                                        width: "16px",
                                        height: "16px",
                                      }}
                                      src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/icon-tick-green.png"
                                      alt="icon"
                                    />
                                    <h6
                                      style={{
                                        margin: "0",
                                      }}
                                    >
                                      AI Powered Daily Journal
                                    </h6>
                                  </div>
                                  <div className="flexRowStart  w-100 al-center">
                                    <img
                                      style={{
                                        width: "16px",
                                        height: "16px",
                                      }}
                                      src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/icon-tick-green.png"
                                      alt="icon"
                                    />
                                    <h6
                                      style={{
                                        margin: "0",
                                      }}
                                    >
                                      AI Powered Personality Test
                                    </h6>
                                  </div>
                                </div>

                                <p
                                  style={{
                                    textAlign: "left",
                                  }}
                                >
                                  Get even more insightful experience from the
                                  deeper discovery of your subconscious
                                </p>
                                <div
                                  className="flexRowStart w-100 al-center pointer"
                                  style={{
                                    justifyContent: "center",
                                  }}
                                  onClick={toggleSeamlessModal}
                                >
                                  <p
                                    style={{
                                      color: "#A0A4D6",
                                      fontSize: "13px",
                                      lineHeight: "18px",
                                      fontWeight: "500",
                                      margin: "0",
                                    }}
                                  >
                                    Seamless Integration
                                  </p>
                                  <img
                                    style={{ width: "12px", height: "12px" }}
                                    src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/icon-help-circle.png"
                                    alt="icon"
                                  />
                                </div>

                                <Button
                                  onClick={() =>
                                    toggleCardPayment(
                                      subscriptionPlans["month_all"]
                                    )
                                  }
                                  className="btn-primary w-100 mt-3 hp-pricing-subscribe-btn"
                                >
                                  Subscribe now
                                </Button>
                                {!isActiveFreeTrial && (
                                  <Button
                                    onClick={() =>
                                      toggleCardPayment(
                                        subscriptionPlans["month_all"],
                                        true
                                      )
                                    }
                                    className="btn-outlined w-100 mt-3 mb-3 hp-pricing-free-btn"
                                  >
                                    {args.noFreeTrialDays} days free trial
                                  </Button>
                                )}
                              </div>
                            </div>
                            {/* <div className="hp-bundle-ribbon">BUNDLE</div> */}
                          </Col>
                        </SwiperSlide>
                        <SwiperSlide key={2}>
                          <Col md="12">
                            <div className="hp-pricing-box">
                              {subscriptionPlans["month_sight"]
                                ?.percentage_off > 0 &&
                                subscriptionPlans["month_sight"].show_plan && (
                                  <div
                                    className="hp-discount-ribbon"
                                    data-ribbon={`-${subscriptionPlans["month_sight"]?.percentage_off}%`}
                                    // style={'--d:0px;--c:orange;--f:25px;'}
                                  ></div>
                                )}

                              <img
                                src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/hp-pricing-img1.png?t=2024-01-10T04%3A18%3A45.558Z"
                                alt=""
                              />

                              <div
                                className={`hp-pricing-box-cont hp-pricing-box-cont-bg3 hp-pricing-box-cont-bg3-new${
                                  isActiveFreeTrial ? "-not-free-monthly" : ""
                                }`}
                              >
                                <div className="flexColStart al-center">
                                  <h5>SEVENTHSIGHT</h5>
                                  {subscriptionPlans["month_sight"]
                                    ?.percentage_off > 0 &&
                                  subscriptionPlans["month_sight"].show_plan ? (
                                    <div className="flexRowStart cg-05">
                                      <h4>
                                        $
                                        {formatNumber(
                                          subscriptionPlans["month_sight"]
                                            ?.special_price
                                        )}
                                      </h4>
                                      <h5 className="striked-discount-price">
                                        <s>
                                          $
                                          {
                                            subscriptionPlans["month_sight"]
                                              ?.price
                                          }
                                        </s>
                                      </h5>
                                    </div>
                                  ) : (
                                    <div className="flexRowStart cg-05">
                                      <h4>
                                        $
                                        {
                                          subscriptionPlans["month_sight"]
                                            ?.price
                                        }
                                      </h4>
                                    </div>
                                  )}
                                </div>
                                <h6>AI Powered Unlimited Dream Analysis.</h6>
                                <p className="hp-min-height-paragraph">
                                  Find insights from your dreams to make
                                  actionable changes in your life. Understand
                                  the symbols and discover the patterns your
                                  subconscious is telling you.
                                </p>

                                <Button
                                  onClick={() =>
                                    toggleCardPayment(
                                      subscriptionPlans["month_sight"]
                                    )
                                  }
                                  className="btn-primary w-100 mt-3 hp-pricing-subscribe-btn"
                                >
                                  Subscribe now
                                </Button>
                                {!isActiveFreeTrial && (
                                  <Button
                                    onClick={() =>
                                      toggleCardPayment(
                                        subscriptionPlans["month_sight"],
                                        true
                                      )
                                    }
                                    className="btn-outlined w-100 mt-3 mb-3 hp-pricing-free-btn"
                                  >
                                    {args.noFreeTrialDays} days free trial
                                  </Button>
                                )}
                              </div>
                            </div>
                          </Col>
                        </SwiperSlide>
                        <SwiperSlide key={3}>
                          <Col md="12">
                            <div className="hp-pricing-box">
                              {subscriptionPlans["month_journal"]
                                ?.percentage_off > 0 &&
                                subscriptionPlans["month_journal"]
                                  .show_plan && (
                                  <div
                                    className="hp-discount-ribbon"
                                    data-ribbon={`-${subscriptionPlans["month_journal"]?.percentage_off}%`}
                                    // style={'--d:0px;--c:orange;--f:25px;'}
                                  ></div>
                                )}

                              <img
                                src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/hp-pricing-img4.png?t=2024-01-10T04%3A25%3A22.143Z"
                                alt=""
                              />

                              <div
                                className={`hp-pricing-box-cont hp-pricing-box-cont-bg3 hp-pricing-box-cont-bg3-new${
                                  isActiveFreeTrial ? "-not-free-monthly" : ""
                                }`}
                              >
                                <div className="flexColStart al-center">
                                  <h5>SEVENTHJOURN</h5>
                                  {subscriptionPlans["month_journal"]
                                    ?.percentage_off > 0 &&
                                  subscriptionPlans["month_journal"]
                                    .show_plan ? (
                                    <div className="flexRowStart cg-05">
                                      <h4>
                                        $
                                        {formatNumber(
                                          subscriptionPlans["month_journal"]
                                            ?.special_price
                                        )}
                                        {/* $0* <u>$10</u> */}
                                      </h4>
                                      <h5 className="striked-discount-price">
                                        <s>
                                          $
                                          {
                                            subscriptionPlans["month_journal"]
                                              ?.price
                                          }
                                        </s>
                                        {/* $0* <u>$10</u> */}
                                      </h5>
                                    </div>
                                  ) : (
                                    <div className="flexRowStart cg-05">
                                      <h4>
                                        $
                                        {
                                          subscriptionPlans["month_journal"]
                                            ?.price
                                        }
                                        {/* $0* <u>$10</u> */}
                                      </h4>
                                    </div>
                                  )}
                                </div>
                                <h6>AI Powered Daily Journal.</h6>
                                <p className="hp-min-height-paragraph">
                                  More than a journal, this AI-powered tool
                                  tracks your mood, analyzes patterns, and
                                  offers personalized insights and resource
                                  recommendations to help your personal growth
                                  and well-being.
                                </p>

                                <Button
                                  onClick={() =>
                                    toggleCardPayment(
                                      subscriptionPlans["month_journal"]
                                    )
                                  }
                                  className="btn-primary w-100 mt-3 hp-pricing-subscribe-btn"
                                >
                                  Subscribe now
                                </Button>
                                {!isActiveFreeTrial && (
                                  <Button
                                    onClick={() =>
                                      toggleCardPayment(
                                        subscriptionPlans["month_journal"],
                                        true
                                      )
                                    }
                                    className="btn-outlined w-100 mt-3 mb-3 hp-pricing-free-btn"
                                  >
                                    {args.noFreeTrialDays} days free trial
                                  </Button>
                                )}
                              </div>
                            </div>
                          </Col>
                        </SwiperSlide>
                        <SwiperSlide key={4}>
                          <Col>
                            <div className="hp-pricing-box hp-pricing-box-disabled">
                              {/* {subscriptionPlans['month_care']?.percentage_off >
														0 &&
														subscriptionPlans['month_care'].show_plan && (
															<div
																className="hp-discount-ribbon"
																data-ribbon={`-${subscriptionPlans['month_care']?.percentage_off}%`}
																// style={'--d:0px;--c:orange;--f:25px;'}
															></div>
														)}
 */}
                              <img
                                src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/hp-pricing-img5.png?t=2024-01-10T04%3A27%3A39.120Z"
                                alt=""
                              />
                              <div
                                className={`hp-pricing-box-cont hp-pricing-box-cont-bg3 hp-pricing-box-cont-bg3-new${
                                  isActiveFreeTrial ? "-not-free-monthly" : ""
                                }`}
                              >
                                <div className="flexColStart al-center">
                                  <h5>SEVENTHCARE</h5>
                                  {/* {subscriptionPlans['month_care']?.percentage_off >
																0 &&
															subscriptionPlans['month_care'].show_plan ? (
																<div className="flexRowStart cg-05">
																	<h4>
																		$
																		{
																			subscriptionPlans['month_care']
																				?.special_price
																		}
																		
																	</h4>
																	<h5 className="striked-discount-price">
																		<s>
																			${subscriptionPlans['month_care']?.price}
																		</s>
																		
																	</h5>
																</div>
															) : ( */}
                                  <div className="flexRowStart cg-05">
                                    <h4>
                                      ${subscriptionPlans["month_care"]?.price}
                                    </h4>
                                  </div>
                                </div>

                                <h6>AI Powered Therapist</h6>
                                <p>
                                  Keep your thoughts noted, track your mood and
                                  get valuable insights with the help of an
                                  AI-powered Daily Journal
                                </p>
                                <h3>
                                  Estimated <br />
                                  2024
                                </h3>
                              </div>
                            </div>
                          </Col>
                        </SwiperSlide>
                        <SwiperSlide key={5}>
                          <Col>
                            <div className="hp-pricing-box hp-pricing-box-disabled">
                              {/* {subscriptionPlans['month_guide']?.percentage_off >
														0 &&
														subscriptionPlans['month_guide'].show_plan && (
															<div
																className="hp-discount-ribbon"
																data-ribbon={`-${subscriptionPlans['month_guide']?.percentage_off}%`}
																// style={'--d:0px;--c:orange;--f:25px;'}
															></div>
														)} */}
                              <img
                                src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/hp-pricing-img3.png?t=2024-01-10T04%3A23%3A26.018Z"
                                alt=""
                              />
                              <div
                                className={`hp-pricing-box-cont hp-pricing-box-cont-bg3 hp-pricing-box-cont-bg3-new${
                                  isActiveFreeTrial ? "-not-free-monthly" : ""
                                }`}
                              >
                                <div className="flexColStart al-center">
                                  <h5>SEVENTHGUIDE</h5>
                                  {/* {subscriptionPlans['month_guide']
																?.percentage_off > 0 &&
															subscriptionPlans['month_guide'].show_plan ? (
																<div className="flexRowStart cg-05">
																	<h4>
																		$
																		{
																			subscriptionPlans['month_guide']
																				?.special_price
																		}
																	</h4>
																	<h5 className="striked-discount-price">
																		<s>
																			${subscriptionPlans['month_guide']?.price}
																		</s>
																		
																	</h5>
																</div>
															) : ( */}
                                  <div className="flexRowStart cg-05">
                                    <h4>
                                      ${subscriptionPlans["month_guide"]?.price}
                                      {/* $0* <u>$10</u> */}
                                    </h4>
                                  </div>
                                </div>
                                <h6>AI Powered Guided Meditations</h6>
                                <p>
                                  Use insights from SeventhSight and communicate
                                  directly with your subconscious to make
                                  radical positive health and habit changes at
                                  your core, and so much more!
                                </p>
                                <h3>
                                  Estimated <br />
                                  2024
                                </h3>
                              </div>
                            </div>
                          </Col>
                        </SwiperSlide>
                        <SwiperSlide key={6}>
                          <Col>
                            <div className="hp-pricing-box hp-pricing-box-disabled">
                              <img
                                src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/hp-pricing-img6.png?t=2024-01-10T04%3A29%3A54.183Z"
                                alt=""
                              />
                              <div
                                className={`hp-pricing-box-cont hp-pricing-box-cont-bg3 hp-pricing-box-cont-bg3-new${
                                  isActiveFreeTrial ? "-not-free-monthly" : ""
                                }`}
                              >
                                <h5>
                                  SEVENTH...?
                                  {/* SeventhGuide $6<sup>99</sup> */}
                                </h5>

                                <h3>
                                  Estimated <br />
                                  2024
                                </h3>
                              </div>
                            </div>
                          </Col>
                        </SwiperSlide>
                        <SliderButtons />
                      </Swiper>
                    </div>
                  </TabPane>
                  <TabPane tabId="2">
                    <div>
                      <Swiper loop {...PricingPlanCarouselSetting}>
                        <SwiperSlide key={1}>
                          <Col md="12">
                            <div className="hp-pricing-box  ">
                              <div
                                className="hp-bundle-ribbon"
                                data-ribbon="BUNDLE"
                                // style={'--d:0px;--c:orange;--f:25px;'}
                              ></div>
                              <img
                                src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/hp-integrated-package.png?t=2024-01-10T04%3A14%3A20.090Z"
                                alt=""
                              />
                              <div
                                className={`hp-pricing-box-cont hp-pricing-box-cont-bg3 hp-pricing-box-cont-bg3-new${
                                  isActiveFreeTrial ? "-not-free" : ""
                                }`}
                              >
                                <div className="flexColStart al-center">
                                  <h5>INTEGRATED PACKAGE</h5>
                                  {subscriptionPlans["year_all"]
                                    ?.percentage_off > 0 &&
                                  subscriptionPlans["year_all"].show_plan ? (
                                    <div className="flexRowStart cg-05">
                                      <h4>
                                        $
                                        {formatNumber(
                                          subscriptionPlans["year_all"]
                                            ?.special_price
                                        )}
                                      </h4>
                                      <h5 className="striked-discount-price">
                                        <s>
                                          $
                                          {subscriptionPlans["year_all"]?.price}
                                        </s>
                                      </h5>
                                    </div>
                                  ) : (
                                    <div className="flexRowStart cg-05">
                                      <h4>
                                        ${subscriptionPlans["year_all"]?.price}
                                      </h4>
                                    </div>
                                  )}
                                  {subscriptionPlans["month_all"]
                                    ?.percentage_off > 0 &&
                                  subscriptionPlans["month_all"].show_plan ? (
                                    <div className="flexColStart al-center">
                                      <p className="text-center">
                                        ( $
                                        {formatNumber(
                                          subscriptionPlans["month_all"]
                                            ?.special_price
                                        )}
                                        /mo )
                                      </p>
                                    </div>
                                  ) : (
                                    <div className="flexColStart al-center">
                                      <p className="text-center">
                                        ( $
                                        {subscriptionPlans["month_all"]?.price}
                                        /mo )
                                      </p>
                                    </div>
                                  )}
                                </div>

                                <div
                                  className="flexColStart w-100 rg-05"
                                  style={{
                                    marginBottom: "16px",
                                  }}
                                >
                                  <div className="flexRowStart  w-100 al-center">
                                    <img
                                      style={{
                                        width: "16px",
                                        height: "16px",
                                      }}
                                      src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/icon-tick-green.png"
                                      alt="icon"
                                    />
                                    <h6
                                      style={{
                                        margin: "0",
                                      }}
                                    >
                                      AI Powered Unlimited Dream Analysis
                                    </h6>
                                  </div>
                                  <div className="flexRowStart  w-100 al-center">
                                    <img
                                      style={{
                                        width: "16px",
                                        height: "16px",
                                      }}
                                      src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/icon-tick-green.png"
                                      alt="icon"
                                    />
                                    <h6
                                      style={{
                                        margin: "0",
                                      }}
                                    >
                                      AI Powered Daily Journal
                                    </h6>
                                  </div>
                                  <div className="flexRowStart  w-100 al-center">
                                    <img
                                      style={{
                                        width: "16px",
                                        height: "16px",
                                      }}
                                      src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/icon-tick-green.png"
                                      alt="icon"
                                    />
                                    <h6
                                      style={{
                                        margin: "0",
                                      }}
                                    >
                                      AI Powered Personality Test
                                    </h6>
                                  </div>
                                </div>
                                <p
                                  style={{
                                    textAlign: "left",
                                  }}
                                >
                                  Get even more insightful experience from the
                                  deeper discovery of your subconscious
                                </p>
                                <div
                                  className="flexRowStart w-100 al-center pointer"
                                  style={{
                                    justifyContent: "center",
                                  }}
                                  onClick={toggleSeamlessModal}
                                >
                                  <p
                                    style={{
                                      color: "#A0A4D6",
                                      fontSize: "13px",
                                      lineHeight: "18px",
                                      fontWeight: "500",
                                      margin: "0",
                                    }}
                                  >
                                    Seamless Integration
                                  </p>
                                  <img
                                    style={{ width: "12px", height: "12px" }}
                                    src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/icon-help-circle.png"
                                    alt="icon"
                                  />
                                </div>
                                <Button
                                  onClick={() =>
                                    toggleCardPayment(
                                      subscriptionPlans["year_all"]
                                    )
                                  }
                                  className="btn-primary w-100 mt-3 hp-pricing-subscribe-btn"
                                >
                                  Subscribe now
                                </Button>
                                {!isActiveFreeTrial && (
                                  <Button
                                    onClick={() =>
                                      toggleCardPayment(
                                        subscriptionPlans["year_all"],
                                        true
                                      )
                                    }
                                    className="btn-outlined w-100 mt-3 mb-3 hp-pricing-free-btn"
                                  >
                                    {args.noFreeTrialDays} days free trial
                                  </Button>
                                )}
                              </div>
                            </div>
                            {/* <div className="hp-bundle-ribbon">BUNDLE</div> */}
                          </Col>
                        </SwiperSlide>
                        <SwiperSlide key={2}>
                          <Col md="12">
                            <div className="hp-pricing-box">
                              {subscriptionPlans["year_sight"]?.percentage_off >
                                0 &&
                                subscriptionPlans["year_sight"].show_plan && (
                                  <div
                                    className="hp-discount-ribbon"
                                    data-ribbon={`-${subscriptionPlans["year_sight"]?.percentage_off}%`}
                                    // style={'--d:0px;--c:orange;--f:25px;'}
                                  ></div>
                                )}
                              <img
                                src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/hp-pricing-img1.png?t=2024-01-10T04%3A18%3A45.558Z"
                                alt=""
                              />

                              <div
                                className={`hp-pricing-box-cont hp-pricing-box-cont-bg3 hp-pricing-box-cont-bg3-new${
                                  isActiveFreeTrial ? "-not-free" : ""
                                }`}
                              >
                                <div className="flexColStart al-center">
                                  <h5>SEVENTHSIGHT</h5>
                                  {subscriptionPlans["year_sight"]
                                    ?.percentage_off > 0 &&
                                  subscriptionPlans["year_sight"].show_plan ? (
                                    <div className="flexRowStart cg-05">
                                      <h4>
                                        $
                                        {formatNumber(
                                          subscriptionPlans["year_sight"]
                                            ?.special_price
                                        )}
                                      </h4>
                                      <h5 className="striked-discount-price">
                                        <s>
                                          $
                                          {
                                            subscriptionPlans["year_sight"]
                                              ?.price
                                          }
                                        </s>
                                      </h5>
                                    </div>
                                  ) : (
                                    <div className="flexRowStart cg-05">
                                      <h4>
                                        $
                                        {subscriptionPlans["year_sight"]?.price}
                                      </h4>
                                    </div>
                                  )}
                                  {subscriptionPlans["month_sight"]
                                    ?.percentage_off > 0 &&
                                  subscriptionPlans["month_sight"].show_plan ? (
                                    <div className="flexColStart al-center">
                                      <p>
                                        ( $
                                        {formatNumber(
                                          subscriptionPlans["month_sight"]
                                            ?.special_price
                                        )}
                                        /mo )
                                      </p>
                                    </div>
                                  ) : (
                                    <div className="flexColStart al-center">
                                      <p>
                                        ( $
                                        {
                                          subscriptionPlans["month_sight"]
                                            ?.price
                                        }
                                        /mo )
                                      </p>
                                    </div>
                                  )}
                                </div>
                                <h6>AI Powered Unlimited Dream Analysis.</h6>
                                <p className="hp-min-height-paragraph">
                                  Find insights from your dreams to make
                                  actionable changes in your life. Understand
                                  the symbols and discover the patterns your
                                  subconscious is telling you.
                                </p>

                                <Button
                                  onClick={() =>
                                    toggleCardPayment(
                                      subscriptionPlans["year_sight"]
                                    )
                                  }
                                  className="btn-primary w-100 mt-3 hp-pricing-subscribe-btn"
                                >
                                  Subscribe now
                                </Button>
                                {!isActiveFreeTrial && (
                                  <Button
                                    onClick={() =>
                                      toggleCardPayment(
                                        subscriptionPlans["year_sight"],
                                        true
                                      )
                                    }
                                    className="btn-outlined w-100 mt-3 mb-3 hp-pricing-free-btn"
                                  >
                                    {args.noFreeTrialDays} days free trial
                                  </Button>
                                )}
                              </div>
                            </div>
                          </Col>
                        </SwiperSlide>
                        <SwiperSlide key={3}>
                          <Col md="12">
                            <div className="hp-pricing-box">
                              {subscriptionPlans["year_journal"]
                                ?.percentage_off > 0 &&
                                subscriptionPlans["year_journal"].show_plan && (
                                  <div
                                    className="hp-discount-ribbon"
                                    data-ribbon={`-${subscriptionPlans["year_journal"]?.percentage_off}%`}
                                    // style={'--d:0px;--c:orange;--f:25px;'}
                                  ></div>
                                )}
                              <img
                                src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/hp-pricing-img4.png?t=2024-01-10T04%3A25%3A22.143Z"
                                alt=""
                              />

                              <div
                                className={`hp-pricing-box-cont hp-pricing-box-cont-bg3 hp-pricing-box-cont-bg3-new${
                                  isActiveFreeTrial ? "-not-free" : ""
                                }`}
                              >
                                <div className="flexColStart al-center">
                                  <h5>SEVENTHJOURN</h5>
                                  {subscriptionPlans["year_journal"]
                                    ?.percentage_off > 0 &&
                                  subscriptionPlans["year_journal"]
                                    .show_plan ? (
                                    <div className="flexRowStart cg-05">
                                      <h4>
                                        $
                                        {formatNumber(
                                          subscriptionPlans["year_journal"]
                                            ?.special_price
                                        )}
                                        {/* $0* <u>$10</u> */}
                                      </h4>
                                      <h5 className="striked-discount-price">
                                        <s>
                                          $
                                          {
                                            subscriptionPlans["year_journal"]
                                              ?.price
                                          }
                                        </s>
                                        {/* $0* <u>$10</u> */}
                                      </h5>
                                    </div>
                                  ) : (
                                    <div className="flexRowStart cg-05">
                                      <h4>
                                        $
                                        {
                                          subscriptionPlans["year_journal"]
                                            ?.price
                                        }
                                        {/* $0* <u>$10</u> */}
                                      </h4>
                                    </div>
                                  )}
                                  {subscriptionPlans["month_journal"]
                                    ?.percentage_off > 0 &&
                                  subscriptionPlans["month_journal"]
                                    .show_plan ? (
                                    <div className="flexColStart al-center">
                                      <p>
                                        ( $
                                        {formatNumber(
                                          subscriptionPlans["month_journal"]
                                            ?.special_price
                                        )}
                                        /mo )
                                      </p>
                                    </div>
                                  ) : (
                                    <div className="flexColStart al-center">
                                      <p>
                                        ( $
                                        {
                                          subscriptionPlans["month_journal"]
                                            ?.price
                                        }
                                        /mo )
                                      </p>
                                    </div>
                                  )}
                                </div>
                                <h6>AI Powered Daily Journal.</h6>
                                <p className="hp-min-height-paragraph">
                                  More than a journal, this AI-powered tool
                                  tracks your mood, analyzes patterns, and
                                  offers personalized insights and resource
                                  recommendations to help your personal growth
                                  and well-being.
                                </p>

                                <Button
                                  onClick={() =>
                                    toggleCardPayment(
                                      subscriptionPlans["year_journal"]
                                    )
                                  }
                                  className="btn-primary w-100 mt-3 hp-pricing-subscribe-btn"
                                >
                                  Subscribe now
                                </Button>
                                {!isActiveFreeTrial && (
                                  <Button
                                    onClick={() =>
                                      toggleCardPayment(
                                        subscriptionPlans["year_journal"],
                                        true
                                      )
                                    }
                                    className="btn-outlined w-100 mt-3 mb-3 hp-pricing-free-btn"
                                  >
                                    {args.noFreeTrialDays} days free trial
                                  </Button>
                                )}
                              </div>
                            </div>
                          </Col>
                        </SwiperSlide>
                        <SwiperSlide key={4}>
                          <Col md="12">
                            <div className="hp-pricing-box">
                              {subscriptionPlans["year_arc"]?.percentage_off >
                                0 &&
                                subscriptionPlans["year_arc"].show_plan && (
                                  <div
                                    className="hp-discount-ribbon"
                                    data-ribbon={`-${subscriptionPlans["year_arc"]?.percentage_off}%`}
                                    // style={'--d:0px;--c:orange;--f:25px;'}
                                  ></div>
                                )}
                              <img
                                src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/hp-pricing-img2.png?t=2024-01-10T04%3A21%3A07.842Z"
                                alt=""
                              />

                              <div
                                className={`hp-pricing-box-cont hp-pricing-box-cont-bg3 hp-pricing-box-cont-bg3-new${
                                  isActiveFreeTrial ? "-not-free" : ""
                                }`}
                              >
                                <div className="flexColStart al-center">
                                  <h5>SEVENTHARC</h5>
                                  {subscriptionPlans["year_arc"]
                                    ?.percentage_off > 0 &&
                                  subscriptionPlans["year_arc"].show_plan ? (
                                    <div className="flexRowStart cg-05">
                                      <h4>
                                        $
                                        {formatNumber(
                                          subscriptionPlans["year_arc"]
                                            ?.special_price
                                        )}
                                        {/* $0* <u>$10</u> */}
                                      </h4>
                                      <h5 className="striked-discount-price">
                                        <s>
                                          $
                                          {subscriptionPlans["year_arc"]?.price}
                                        </s>
                                        {/* $0* <u>$10</u> */}
                                      </h5>
                                    </div>
                                  ) : (
                                    <div className="flexRowStart cg-05">
                                      <h4>
                                        ${subscriptionPlans["year_arc"]?.price}
                                        {/* $0* <u>$10</u> */}
                                      </h4>
                                    </div>
                                  )}
                                </div>
                                <h6>AI Powered In-depth Personality Test</h6>
                                <p className="hp-min-height-paragraph">
                                  Find your archetype and your personal journey.
                                  We'll integrate your personal Archetype into
                                  your dedicated account for even better
                                  insights into your dreams and meditation
                                  visions.
                                </p>
                                <div
                                  className="flexRowStart w-100 al-center pointer"
                                  style={{
                                    justifyContent: "center",
                                  }}
                                >
                                  <p
                                    style={{
                                      color: "#A0A4D6",
                                      fontSize: "13px",
                                      lineHeight: "18px",
                                      fontWeight: "500",
                                      margin: "0",
                                    }}
                                  >
                                    *Single Charge, Free Integration
                                  </p>
                                </div>

                                <Button
                                  onClick={() =>
                                    toggleCardPayment(
                                      subscriptionPlans["year_arc"]
                                    )
                                  }
                                  className="btn-primary w-100 mt-3 hp-pricing-subscribe-btn"
                                >
                                  Subscribe now
                                </Button>
                              </div>
                            </div>
                          </Col>
                        </SwiperSlide>
                        <SwiperSlide key={5}>
                          <Col>
                            <div className="hp-pricing-box hp-pricing-box-disabled">
                              {/* {subscriptionPlans['year_care']?.percentage_off > 0 &&
														subscriptionPlans['year_care'].show_plan && (
															<div
																className="hp-discount-ribbon"
																data-ribbon={`-${subscriptionPlans['year_care']?.percentage_off}%`}
																// style={'--d:0px;--c:orange;--f:25px;'}
															></div>
														)} */}
                              <img
                                src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/hp-pricing-img5.png?t=2024-01-10T04%3A27%3A39.120Z"
                                alt=""
                              />
                              <div
                                className={`hp-pricing-box-cont hp-pricing-box-cont-bg3 hp-pricing-box-cont-bg3-new${
                                  isActiveFreeTrial ? "-not-free" : ""
                                }`}
                              >
                                <div className="flexColStart al-center">
                                  <h5>SEVENTHCARE</h5>
                                  {/* {subscriptionPlans['year_care']?.percentage_off >
																0 &&
															subscriptionPlans['year_care'].show_plan ? (
																<div className="flexRowStart cg-05">
																	<h4>
																		$
																		{
																			subscriptionPlans['year_care']
																				?.special_price
																		}
																		
																	</h4>
																	<h5 className="striked-discount-price">
																		<s>
																			${subscriptionPlans['year_care']?.price}
																		</s>
																		
																	</h5>
																</div>
															) : ( */}
                                  <div className="flexRowStart cg-05">
                                    <h4>
                                      ${subscriptionPlans["year_care"]?.price}
                                      {/* $0* <u>$10</u> */}
                                    </h4>
                                  </div>
                                </div>
                                <h6>AI Powered Therapist</h6>
                                <p>
                                  Keep your thoughts noted, track your mood and
                                  get valuable insights with the help of an
                                  AI-powered Daily Journal
                                </p>
                                <h3>
                                  Estimated <br />
                                  2024
                                </h3>
                              </div>
                            </div>
                          </Col>
                        </SwiperSlide>
                        <SwiperSlide key={6}>
                          <Col>
                            <div className="hp-pricing-box hp-pricing-box-disabled">
                              {/* {subscriptionPlans['year_guide']?.percentage_off >
														0 &&
														subscriptionPlans['year_guide'].show_plan && (
															<div
																className="hp-discount-ribbon"
																data-ribbon={`-${subscriptionPlans['year_guide']?.percentage_off}%`}
																// style={'--d:0px;--c:orange;--f:25px;'}
															></div>
														)} */}
                              <img
                                src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/hp-pricing-img3.png?t=2024-01-10T04%3A23%3A26.018Z"
                                alt=""
                              />
                              <div
                                className={`hp-pricing-box-cont hp-pricing-box-cont-bg3 hp-pricing-box-cont-bg3-new${
                                  isActiveFreeTrial ? "-not-free" : ""
                                }`}
                              >
                                <div className="flexColStart al-center">
                                  <h5>SEVENTHGUIDE</h5>
                                  {/* {subscriptionPlans['year_guide']?.percentage_off >
																0 &&
															subscriptionPlans['year_guide'].show_plan ? (
																<div className="flexRowStart cg-05">
																	<h4>
																		$
																		{
																			subscriptionPlans['year_guide']
																				?.special_price
																		}
																		
																	</h4>
																	<h5 className="striked-discount-price">
																		<s>
																			${subscriptionPlans['year_guide']?.price}
																		</s>
																		
																	</h5>
																</div>
															) : ( */}
                                  <div className="flexRowStart cg-05">
                                    <h4>
                                      ${subscriptionPlans["year_guide"]?.price}
                                    </h4>
                                  </div>
                                </div>
                                <h6>AI Powered Guided Meditations</h6>
                                <p>
                                  Use insights from SeventhSight and communicate
                                  directly with your subconscious to make
                                  radical positive health and habit changes at
                                  your core, and so much more!
                                </p>
                                <h3>
                                  Estimated <br />
                                  2024
                                </h3>
                              </div>
                            </div>
                          </Col>
                        </SwiperSlide>
                        <SwiperSlide key={7}>
                          <Col>
                            <div className="hp-pricing-box hp-pricing-box-disabled">
                              <img
                                src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/hp-pricing-img6.png?t=2024-01-10T04%3A29%3A54.183Z"
                                alt=""
                              />
                              <div
                                className={`hp-pricing-box-cont hp-pricing-box-cont-bg3 hp-pricing-box-cont-bg3-new${
                                  isActiveFreeTrial ? "-not-free" : ""
                                }`}
                              >
                                <h5>
                                  Seventh...?
                                  {/* SeventhGuide $6<sup>99</sup> */}
                                </h5>

                                <h3>
                                  Estimated <br />
                                  2024
                                </h3>
                              </div>
                            </div>
                          </Col>
                        </SwiperSlide>
                        <SliderButtons />
                      </Swiper>
                    </div>
                  </TabPane>
                </TabContent>
              </Col>
            </Row>

            {/* <Row>
						<Col className="text-center">
							<Button
								className="btn-primary btn-shadow"
								onClick={() => {
									const planDetails =
										currentActiveTab === '1'
											? subscriptionPlans['month_all']
											: subscriptionPlans['year_all'];

									toggleCardPayment(planDetails);
								}}
							>
								Order All In One (
								{currentActiveTab === '1'
									? `$${subscriptionPlans['month_all']?.price}/mo`
									: `$${subscriptionPlans['year_all']?.price}/yr`}
								)
							</Button>
						</Col>
					</Row> */}
          </Container>
        )}
        {showform && clientSecret && (
          <div
            // ref={messagesEndRef}
            className="container"
            style={{ marginTop: "100px" }}
          >
            <Elements
              stripe={stripepromise}
              options={options}
              paymentMethod={paymentMethod}
              clientSecret={clientSecret}
            >
              <CheckoutForm
                paymentMethod={paymentMethod}
                clientSecret={clientSecret}
                toggleLoader={toggleLoader}
                toggleCancel={toggleCancel}
              />
            </Elements>
          </div>
        )}

        <Modal
          size="lg"
          style={{ maxWidth: "890px", width: "100%" }}
          isOpen={modalCardPayment}
          toggle={toggleCardPayment}
        >
          <ModalHeader toggle={toggleCardPayment}></ModalHeader>
          <ModalBody className="modal-card-payment">
            <Row>
              <Col md={6}>
                <h3>Payment Details</h3>
                <Form>
                  <FormGroup>
                    <Label for="exampleAddress">Email Address</Label>
                    <Input value={email} disabled={true} />
                  </FormGroup>
                  <FormGroup>
                    <Label for="cardholderName">Name</Label>
                    <Input
                      // placeholder="Steve Harvey"
                      onChange={(e) => setCardholderName(e.target.value)}
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label for="exampleAddress">Credit Card Number</Label>
                    <Input
                      placeholder="****   ****   ****   ****"
                      value={card_number(cardNumber)}
                      onChange={(e) => setCardNumber(e.target.value)}
                    />
                  </FormGroup>

                  <Row>
                    <Col md={6}>
                      <Label for="exampleEmail">Expiry Date</Label>
                      <Row>
                        <Col md={6}>
                          <FormGroup>
                            <Input
                              max={2}
                              placeholder="MM"
                              onChange={(e) =>
                                setExpirationMonth(e.target.value)
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col md={6}>
                          <FormGroup>
                            <Input
                              max={2}
                              placeholder="YY"
                              onChange={(e) =>
                                setExpirationYear(e.target.value)
                              }
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="examplePassword">CVV</Label>
                        <Input
                          max={4}
                          placeholder="***"
                          type="password"
                          onChange={(e) => setCVV(e.target.value)}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <FormGroup check className="mb-2">
                    <Input type="checkbox" onChange={hnadleShowPromoCode} />{" "}
                    <Label check>I have a promo code</Label>
                  </FormGroup>

                  {showPromoCodeInput && (
                    <FormGroup>
                      <Label for="exampleAddress">Enter Promo code</Label>
                      <div className="position-relative">
                        {/* <Input
                          id="exampleAddress"
                          name="address"
                          // placeholder="E-256125"
                          value={promoCode}
                          autoComplete="off"
                          onChange={(e) => {
                            setPromoCode(e.target.value);
                            VerifyGiftCode();
                          }}
                        />
                        {couponVerified && (
                          <div className="card-payment-verified">
                            <CheckCircleRoundedIcon /> Verified
                          </div>
                        )} */}
                        {/* <div className="card-payment-verified">
												<CheckCircleRoundedIcon /> Verified
											</div> */}
                      </div>
                    </FormGroup>
                  )}

                  <Row>
                    <Col className="text-primary">Total Amount</Col>
                    <Col className="text-right">
                      = $
                      {discountAmount !== "" && discountAmount >= 0
                        ? Number(discountAmount).toFixed(2)
                        : planDetails?.percentage_off > 0
                        ? planDetails.special_price
                        : planDetails.price}
                    </Col>
                  </Row>

                  <Row className="mb-4 mt-4">
                    <Col>
                      <Button
                        type="submit"
                        className="w-100 btn-primary"
                        onClick={(e) => {
                          e.preventDefault();
                          handlePayment();
                        }}
                      >
                        Make Payment
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Col>
              {/* <Col md={6}>
                <img src={cardPaymentThumb} alt="" />
              </Col> */}
            </Row>
          </ModalBody>
        </Modal>
        <Modal
          size="lg"
          // style={{ maxWidth: "890px", width: "100%" }}
          isOpen={modalstripecard}
          toggle={closestripemodal}
        >
          <ModalHeader toggle={closestripemodal}></ModalHeader>
          <ModalBody className="modal-card-payment">
            <Row>
              <Col md={6}>
                <h3>Payment Details</h3>
                <Form>
                  {free_trial && (
                    <FormGroup check className="mb-2">
                      <Input
                        id="freetrialCheckbox"
                        type="checkbox"
                        value={freetrialPayment}
                        onChange={() => {
                          setFreetrialPayment((prev) => !prev);
                          // console.log(freetrialPayment);
                        }}
                        // checked
                        defaultChecked={true}
                      />{" "}
                      <Label
                        className="pointer"
                        htmlFor="freetrialCheckbox"
                        /* onClick={() => {
                          setFreetrialPayment((prev) => !prev);
                          console.log(freetrialPayment);
                        }} */
                      >
                        Enter payment details now and pay in{" "}
                        {args.noFreeTrialDays} days, cancel anytime.
                      </Label>
                    </FormGroup>
                  )}

                  <FormGroup>
                    <Label for="exampleAddress">Email Address</Label>
                    <Input value={email} disabled={true} />
                  </FormGroup>
                  <FormGroup>
                    <Label for="cardholderName">Name</Label>
                    <Input
                      value={stripedetail["name"]}
                      // placeholder="Steve Harvey"
                      onChange={(e) =>
                        handlestripedetail(e.target.value, "name")
                      }
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label for="exampleAddress">Address</Label>
                    <Input
                      placeholder="Address"
                      value={stripedetail["address"]}
                      onChange={(e) =>
                        handlestripedetail(e.target.value, "address")
                      }
                    />
                  </FormGroup>

                  <Row>
                    <Col md={6}>
                      <Label for="exampleEmail">Country</Label>
                      <FormGroup className="countryregion">
                        <CountryDropdown
                          value={stripedetail["country"]}
                          onChange={(val) => handlestripedetail(val, "country")}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup className="countryregion">
                        <Label for="examplePassword">State</Label>

                        <RegionDropdown
                          country={stripedetail["country"]}
                          value={stripedetail["state"]}
                          onChange={(val) => handlestripedetail(val, "state")}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <Label for="exampleEmail">City</Label>
                      <FormGroup>
                        <Input
                          placeholder="City"
                          value={stripedetail["city"]}
                          onChange={(e) =>
                            handlestripedetail(e.target.value, "city")
                          }
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="examplePassword">Postal Code</Label>
                        <Input
                          placeholder="Postal Code"
                          value={stripedetail["zip"]}
                          maxLength={7}
                          onChange={(e) => {
                            const inputValue = e.target.value;
                            // Check if the entered value is a number
                            if (!isNaN(inputValue)) {
                              handlestripedetail(inputValue, "zip");
                            }
                          }}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  {!free_trial && (
                    <>
                      <FormGroup check className="mb-2">
                        <Input
                          // className="new-input-check"
                          id="giftCoupon"
                          type="checkbox"
                          onChange={handleShowGiftCode}
                        />{" "}
                        <Label
                          check
                          className="pointer"
                          htmlFor="giftCoupon"
                          /* onClick={handleShowGiftCode} */
                        >
                          Apply gift card
                        </Label>
                      </FormGroup>

                      {showGiftCodeInput && (
                        <FormGroup>
                          <Label for="exampleAddress">
                            Enter Gift Card number
                          </Label>
                          <div className="position-relative">
                            <Input
                              id="exampleAddress"
                              name="address"
                              // placeholder="E-256125"
                              value={giftCode === null ? "" : giftCode}
                              onChange={(e) => {
                                setGiftCode((prev) => e.target.value);
                              }}
                            />
                            {giftCouponVerified && (
                              <div className="card-payment-verified">
                                <CheckCircleRoundedIcon /> Verified
                              </div>
                            )}
                            {/* <div className="card-payment-verified">
												<CheckCircleRoundedIcon /> Verified
											</div> */}
                          </div>
                        </FormGroup>
                      )}
                      {zeroAmountGift && (
                        <>
                          <FormGroup check className="mb-2">
                            <Input
                              type="checkbox"
                              onChange={hnadleShowPromoCode}
                              id="promocoupon"
                            />{" "}
                            <Label
                              check
                              className="pointer"
                              htmlFor="promocoupon"
                              /*onClick={hnadleShowPromoCode} */
                            >
                              I have a Promo code
                            </Label>
                          </FormGroup>

                          {showPromoCodeInput && (
                            <FormGroup>
                              <Label for="exampleAddress">
                                Enter Promo code
                              </Label>
                              <div className="position-relative">
                                <Input
                                  id="exampleAddress"
                                  name="address"
                                  // placeholder="E-256125"
                                  value={promoCode === null ? "" : promoCode}
                                  onChange={(e) => {
                                    setPromoCode((prev) => e.target.value);
                                  }}
                                />
                                {couponVerified && (
                                  <div className="card-payment-verified">
                                    <CheckCircleRoundedIcon /> Verified
                                  </div>
                                )}
                              </div>
                            </FormGroup>
                          )}
                        </>
                      )}
                    </>
                  )}
                  {!free_trial && (
                    <>
                      <Row className="mb-2">
                        <Col className="">Price</Col>
                        <Col className="text-right">
                          $
                          {planDetails?.percentage_off > 0
                            ? planDetails.special_price
                            : planDetails.price}
                        </Col>
                      </Row>
                      {giftCode && (
                        <Row className="mb-2">
                          <Col className="">Gift Card</Col>
                          <Col className="text-right">
                            {`-$${giftCardAmount ? giftCardAmount : 0}`}
                          </Col>
                        </Row>
                      )}
                      {promoCode && zeroAmountGift && (
                        <Row className="mb-2">
                          <Col className="">Promo Code</Col>
                          <Col className="text-right">
                            {`-$${promoCodeAmount ? promoCodeAmount : 0}`}
                          </Col>
                        </Row>
                      )}
                      <hr />
                    </>
                  )}

                  <Row>
                    <Col className="text-primary">Total Cost</Col>
                    <Col className="text-right">
                      ={" "}
                      {free_trial
                        ? "$0"
                        : discountAmount !== "" && discountAmount >= 0
                        ? `$${discountAmount}`
                        : `$${
                            planDetails?.percentage_off > 0
                              ? planDetails.special_price
                              : planDetails.price
                          }`}
                    </Col>
                  </Row>

                  <Row className="mb-4 mt-4">
                    <Col>
                      <Button
                        type="submit"
                        className="w-100 btn-primary"
                        onClick={(e) => {
                          e.preventDefault();
                          if (
                            (free_trial && freetrialPayment) ||
                            (showPromoCodeInput &&
                              promoCode !== null &&
                              (discountAmount === 0 ||
                                discountAmount.toString() === "0.00")) ||
                            (giftCode !== null && discountAmount === 0)
                          ) {
                            handleFreetrialGiftPayment();
                          } else {
                            handleStripePayment();
                          }
                        }}
                      >
                        {free_trial ? "Continue" : "Make Payment"}
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Col>
              <Col md={6}>
                <div className="buygift_rightbox mt-0">
                  <div className="text-center">
                    {planDetails["unique_key"] === "month_all" ||
                    planDetails["unique_key"] === "year_all" ? (
                      <img
                        src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/hp-integrated-package.png?t=2024-01-10T04%3A14%3A20.090Z"
                        about=""
                      />
                    ) : planDetails["unique_key"] === "month_sight" ||
                      planDetails["unique_key"] === "year_sight" ? (
                      <img
                        src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/hp-pricing-img1.png?t=2024-01-10T04%3A18%3A45.558Z"
                        about=""
                      />
                    ) : planDetails["unique_key"] === "month_journal" ||
                      planDetails["unique_key"] === "year_journal" ? (
                      <img
                        src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/hp-pricing-img4.png?t=2024-01-10T04%3A25%3A22.143Z"
                        about=""
                      />
                    ) : planDetails["unique_key"] === "month_arc" ||
                      planDetails["unique_key"] === "year_arc" ? (
                      <img
                        src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/hp-pricing-img2.png?t=2024-01-10T04%3A21%3A07.842Z"
                        about=""
                      />
                    ) : (
                      <img
                        src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/hp-pricing-img2.png?t=2024-01-10T04%3A21%3A07.842Z"
                        about=""
                      />
                    )}
                  </div>

                  <div className="buygift-box-inner">
                    <div className="buygift-box-inner-title border-0 text-center">
                      <Row>
                        <Col>
                          <h4>
                            {(planDetails["unique_key"] === "month_all" ||
                              planDetails["unique_key"] === "year_all") && (
                              <>INTEGRATED PACKAGE</>
                            )}
                            {(planDetails["unique_key"] === "month_sight" ||
                              planDetails["unique_key"] === "year_sight") && (
                              <>SEVENTHSIGHT</>
                            )}
                            {(planDetails["unique_key"] === "month_journal" ||
                              planDetails["unique_key"] === "year_journal") && (
                              <>SEVENTHJOURN</>
                            )}
                            {(planDetails["unique_key"] === "month_arc" ||
                              planDetails["unique_key"] === "year_arc") && (
                              <>SEVENTHARC</>
                            )}{" "}
                            $
                            {subscriptionPlans["month_journal"]
                              ?.percentage_off > 0 && plan_type_prod
                              ? planDetails["special_price"]
                              : planDetails?.percentage_off > 0
                              ? planDetails["special_price"]
                              : planDetails["price"]}{" "}
                            /{planDetails["duration"] === "year" ? "YR" : "MO"}
                          </h4>
                          {free_trial && (
                            <p style={{ fontSize: "22px" }}>
                              {args.noFreeTrialDays} days free trial
                            </p>
                          )}
                          {(planDetails["unique_key"] === "month_all" ||
                            planDetails["unique_key"] === "year_all") && (
                            <>
                              <h5>AI Powered Unlimited Dream Analysis.</h5>
                              <h5>AI Powered Daily Journal.</h5>
                            </>
                          )}
                          {(planDetails["unique_key"] === "month_sight" ||
                            planDetails["unique_key"] === "year_sight") && (
                            <>
                              <h5>AI Powered Unlimited Dream Analysis.</h5>
                            </>
                          )}
                          {(planDetails["unique_key"] === "month_journal" ||
                            planDetails["unique_key"] === "year_journal") && (
                            <>
                              <h5>AI Powered Daily Journal.</h5>
                            </>
                          )}
                          {(planDetails["unique_key"] === "month_arc" ||
                            planDetails["unique_key"] === "year_arc") && (
                            <>
                              <h5>AI Powered In-depth Personality Test.</h5>
                            </>
                          )}
                        </Col>
                      </Row>
                    </div>
                    <div className="buygift-box-list">
                      {(planDetails["unique_key"] === "month_all" ||
                        planDetails["unique_key"] === "year_all") && (
                        <p
                          style={{
                            textAlign: "center",
                          }}
                        >
                          Get even more insightful experience from the deeper
                          discovery of your subconscious
                        </p>
                      )}
                      {(planDetails["unique_key"] === "month_sight" ||
                        planDetails["unique_key"] === "year_sight") && (
                        <p
                          style={{
                            textAlign: "center",
                          }}
                        >
                          Find insights from your dreams to make actionable
                          changes in your life. Understand the symbols and
                          discover the patterns your subconscious is telling
                          you.
                        </p>
                      )}
                      {(planDetails["unique_key"] === "month_journal" ||
                        planDetails["unique_key"] === "year_journal") && (
                        <p
                          style={{
                            textAlign: "center",
                          }}
                        >
                          More than a journal, this AI-powered tool tracks your
                          mood, analyzes patterns, and offers personalized
                          insights and resource recommendations to help your
                          personal growth and well-being.
                        </p>
                      )}
                      {(planDetails["unique_key"] === "month_arc" ||
                        planDetails["unique_key"] === "year_arc") && (
                        <p
                          style={{
                            textAlign: "center",
                          }}
                        >
                          Find your archetype and your personal journey. We'll
                          integrate your personal Archetype into your dedicated
                          account for even better insights into your dreams and
                          meditation visions.
                        </p>
                      )}

                      {/* {planDetails['unique_key'] === 'month_all' ||
												(planDetails['unique_key'] === 'year_all' && (
													<ul>
														<li>
															<CheckCircleRoundedIcon className="hp-check-icon" />{' '}
															<span>All Feature </span>in basic included
														</li>

														<li>
															<CheckCircleRoundedIcon className="hp-check-icon" />{' '}
															<span>All Feature </span>in basic included
														</li>

														<li>
															<CheckCircleRoundedIcon className="hp-check-icon" />{' '}
															<span>All Feature </span>in basic included
														</li>

														<li>
															<CheckCircleRoundedIcon className="hp-check-icon" />{' '}
															<span>All Feature </span>in basic included
														</li>
													</ul>
												))} */}
                      {/* <ul>
												<li>
													<CheckCircleRoundedIcon className="hp-check-icon" />{' '}
													<span>All Feature </span>in basic included
												</li>

												<li>
													<CheckCircleRoundedIcon className="hp-check-icon" />{' '}
													<span>All Feature </span>in basic included
												</li>

												<li>
													<CheckCircleRoundedIcon className="hp-check-icon" />{' '}
													<span>All Feature </span>in basic included
												</li>

												<li>
													<CheckCircleRoundedIcon className="hp-check-icon" />{' '}
													<span>All Feature </span>in basic included
												</li>
											</ul> */}
                    </div>
                    {/* <Row>
													<Col>
														<p>Subscribe and start analyse your Dream today!</p>
													</Col>
												</Row>

												<Row className="buygift-modify-plan">
													<Col>
														<p>
															<strong>Modify Plan</strong>
														</p>
													</Col>
												</Row> */}
                  </div>
                </div>
                {/* <img src={cardPaymentThumb} alt="" /> */}
              </Col>
            </Row>
          </ModalBody>
        </Modal>

        <Modal isOpen={modalPaymentDone} toggle={togglePaymentDone}>
          <ModalHeader toggle={togglePaymentDone}></ModalHeader>
          <ModalBody>
            <div className="text-center payment-done-modal">
              <div>
                <CheckCircleRoundedIcon className="payment-done-checkicon" />
              </div>
              <h3>Congratulations</h3>
              <p>
                Your payment done <br />
                successfully !
              </p>
              <Button
                className="w-50 btn-primary"
                onClick={() => {
                  togglePaymentDone();
                }}
              >
                Done
              </Button>
            </div>
          </ModalBody>
        </Modal>
        <Modal
          isOpen={seamlessModal}
          toggle={toggleSeamlessModal}
          style={
            window.innerWidth > 600
              ? {
                  // position: 'absolute',
                  top: "50%",
                  transform: "translateY(-50%)",
                }
              : {
                  top: "0%",
                  transform: "translateY(0%)",
                }
          }
          className="modal-lg"
        >
          <ModalHeader
            toggle={toggleSeamlessModal}
            style={{ paddingTop: "0px", paddingBottom: "0px" }}
          >
            {window.innerWidth > 600 ? (
              <h2
                style={{
                  fontSize: "20px",
                  lineHeight: "32px",
                  paddingTop: "30px",
                  fontWeight: "400",
                }}
              >
                While each of these services is independently designed, together
                they weave a tapestry of insights about your inner self
              </h2>
            ) : (
              <h5
                style={{
                  fontSize: "20px",
                  lineHeight: "32px",
                  paddingTop: "30px",
                  fontWeight: "400",
                }}
              >
                While each of these services is independently designed, together
                they weave a tapestry of insights about your inner self
              </h5>
            )}
          </ModalHeader>
          <ModalBody style={{ paddingTop: "0px" }}>
            <div className="flexColCenter al-center ">
              <img
                // className="icon-48"
                style={
                  window.innerWidth > 600
                    ? {
                        flex: 1,
                        paddingTop: "16px",
                        paddingBottom: "16px",
                        maxWidth: "690px",
                        maxHeight: "196px",
                      }
                    : {
                        flex: 1,
                        paddingTop: "16px",
                        paddingBottom: "16px",
                        maxWidth: "358px",
                        maxHeight: "102px",
                      }
                }
                src="https://db.seventhsight.com/storage/v1/object/public/Website_Images/hp_services_icons.png?t=2024-01-10T04%3A54%3A02.823Z"
                alt=""
              />
            </div>
            <p style={{ textAlign: "center" }}>
              An example of their collaborative power might be, if you were
              anxious about an upcoming project, you then express this in
              SeventhJOURNAL as you spend a few moments reflecting on your day.
              The manifestation of a dream symbol that night, such as teeth
              falling out, analyzed by SeventhSIGHT, might then be linked to
              this underlying stress. As a response, SeventhGUIDE tailors your
              next day's meditation frequencies specifically to reduce your
              anxiety. The refined understanding of your archetype from
              SeventhARC enriches this process by identifying techniques best
              suited to your personality type. This detailed profile is then
              shared with your dedicated counselor in SeventhCARE, allowing them
              to provide personalized guidance, if you choose, alleviating any
              lingering anxiety, and providing pragmatic solutions to navigate
              life's challenges.
            </p>
          </ModalBody>
        </Modal>
        <Modal isOpen={upgradeModal} toggle={toggleUpgradeModal}>
          <ModalHeader toggle={toggleUpgradeModal}></ModalHeader>
          <ModalBody>
            <div className="text-center payment-done-modal analyze-form ">
              <div>
                <div>
                  <CheckCircleRoundedIcon className="payment-done-checkicon" />
                </div>
                <h3>Payment Method Confirmation</h3>

                <>
                  <FormGroup check className="mb-3">
                    <Input
                      type="radio"
                      name="paymentMethod"
                      id="updateExistingPaymentMethod"
                      className="pointer"
                      onChange={() =>
                        handlePaymentMethodChange("updateExisting")
                      }
                      checked={paymentMethodType === "updateExisting"}
                    />
                    <Label
                      check
                      style={{ float: "left" }}
                      htmlFor="updateExistingPaymentMethod"
                      className="pointer"
                    >
                      Update with existing payment method
                    </Label>
                  </FormGroup>

                  <FormGroup check className="mb-3">
                    <Input
                      type="radio"
                      name="paymentMethod"
                      id="addNewPaymentMethod"
                      onChange={() => handlePaymentMethodChange("addNew")}
                      checked={paymentMethodType === "addNew"}
                      className="pointer"
                    />
                    <Label
                      check
                      style={{ float: "left" }}
                      htmlFor="addNewPaymentMethod"
                      className="pointer"
                    >
                      Add new payment method
                    </Label>
                  </FormGroup>
                </>

                <div className="d-flex justify-content-end">
                  <Button
                    className="btn-primary me-2"
                    onClick={toggleUpgradeModal}
                  >
                    Cancel
                  </Button>
                  <Button
                    className="btn-primary"
                    onClick={() => updateSubscription()}
                  >
                    Submit
                  </Button>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Modal
          isOpen={showPendingModal}
          toggle={togglePendingModal}
          backdrop="static"
        >
          <ModalHeader toggle={() => togglePendingModal(true)}></ModalHeader>
          <ModalBody>
            <div className="text-center payment-done-modal analyze-form ">
              <div>
                <div>
                  <CheckCircleRoundedIcon className="payment-done-checkicon" />
                </div>
                <h3>Confirmation</h3>
                <p style={{ fontSize: "22px" }}>
                  You currently have a pending payment of{" "}
                  <span className="text-primary fw-bold">${pendingAmount}</span>{" "}
                  for your{" "}
                  <span className="text-primary fw-bold">
                    {pendingSubscription}
                  </span>
                  .
                </p>
                <p style={{ fontSize: "22px" }}>
                  To ensure uninterrupted access to our premium services, would
                  you like to proceed with the payment now?
                </p>

                <div className="d-flex justify-content-end">
                  <Button
                    className="btn-primary me-2"
                    onClick={() => {
                      togglePendingModal();
                      togglePendingWarningModal();
                    }}
                  >
                    Yes
                  </Button>
                  <Button
                    className="btn-primary"
                    onClick={() => togglePendingModal(true)}
                  >
                    No
                  </Button>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Modal
          isOpen={warningModal}
          toggle={togglePendingWarningModal}
          backdrop="static"
        >
          <ModalHeader
            toggle={() => togglePendingWarningModal(true)}
          ></ModalHeader>
          <ModalBody>
            <div className="text-center payment-done-modal analyze-form ">
              <div>
                <div>
                  <InfoIcon
                    className="payment-done-checkicon"
                    style={{ color: "red" }}
                  />
                </div>
                {/* <h3>Info</h3> */}

                <p style={{ fontSize: "22px" }}>
                  Please refrain from reloading this page, closing the browser,
                  or navigating away until your payment process is complete.
                  Doing so may result in transaction errors or delays. We
                  appreciate your patience and cooperation as we ensure a smooth
                  and successful payment experience for you. If you encounter
                  any issues, please reach out to our support team for
                  assistance. Thank you!
                </p>

                <div className="d-flex justify-content-end">
                  <Button
                    className="btn-primary"
                    onClick={() => {
                      togglePendingWarningModal();
                      handlePendingPayment();
                    }}
                  >
                    Proceed
                  </Button>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    </div>
  );
};

export default CardPayment;
const SliderButtons = () => {
  const swiper = useSwiper();
  return (
    <div className="flexCenter w-100 cg-1" style={{ marginTop: "1rem" }}>
      <RoundButtonDark
        type={"backward"}
        filled={false}
        onClick={() => {
          swiper.slidePrev();
        }}
      />
      <RoundButtonDark
        type={"forward"}
        filled={false}
        onClick={() => {
          swiper.slideNext();
        }}
      />
    </div>
  );
};
